"use client";
import { useState, useEffect, useCallback } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import { Card, CardContent } from "../components/ui/Card";
import { Button } from "../components/ui/Button";
import { Input } from "../components/ui/Input";
import { Badge } from "../components/ui/Badge";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/Tabs";
import { ArrowLeft, ShoppingCart, Package, DollarSign, XCircle, Star, Wrench, Loader2, Eye, Edit3, Users, Calendar, ChevronDown, ChevronUp, Info, Truck, Clock, CheckCircle, Trash2 } from "lucide-react";
import { AdicionarManutencaoDialog } from "../components/dialogs/AdicionarManutencaoDialog";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/Dialog";
import { Label } from "../components/ui/Label";
import { toast } from "sonner";
import { api } from "../services/api";
import { customerService } from "../services/customers";
import { AsyncSelect } from "../components/AsyncSelect";
import { getImageUrl, limitPercentage } from "../utils";

export function ProdutosClientePage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const formatCurrency = (value: string | number) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value || 0));
  };

  const activeTab = searchParams.get("tab") || "compras";
  const currentPage = parseInt(searchParams.get("page") || "1", 10);

  const [isLoading, setIsLoading] = useState(true);
  const [customer, setCustomer] = useState<any>(null);
  const [dataList, setDataList] = useState<any[]>([]);
  const [pagination, setPagination] = useState({ current_page: 1, last_page: 1, total: 0 });
  const [counts, setCounts] = useState({ published: 0, saled: 0, paidout: 0, returned: 0, compras: 0, desistence: 0 });
  const [isUserView, setIsUserView] = useState(false);

  const getPageNumbers = (currentPage: number, totalPages: number) => {
    const pages: (number | string)[] = [];
    const maxVisible = 5;

    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    return pages;
  };

  const [referrals, setReferrals] = useState<any[]>([]);
  const [loadingReferrals, setLoadingReferrals] = useState(false);
  const [selectedReferredId, setSelectedReferredId] = useState<string>("");
  const [selectedReferredCustomer, setSelectedReferredCustomer] = useState<any>(null);
  const [confirmTransferDialogOpen, setConfirmTransferDialogOpen] = useState(false);
  const [isSubmittingReferral, setIsSubmittingReferral] = useState(false);
  const [editingCommissions, setEditingCommissions] = useState<Record<number, string>>({});

  // Modais de Indicações
  const [editCommissionDialogOpen, setEditCommissionDialogOpen] = useState(false);
  const [selectedReferredForEdit, setSelectedReferredForEdit] = useState<any>(null);
  const [editingCommissionValue, setEditingCommissionValue] = useState("");
  const [isSavingCommission, setIsSavingCommission] = useState(false);

  // Modal de Edição de Datas (Exclusivo ronald@ronald.com)
  const [currentUserEmail, setCurrentUserEmail] = useState<string>("");
  const [editDatesDialogOpen, setEditDatesDialogOpen] = useState(false);
  const [selectedReferredForEditDates, setSelectedReferredForEditDates] = useState<any>(null);
  const [editingStartedAt, setEditingStartedAt] = useState("");
  const [editingEndedAt, setEditingEndedAt] = useState("");
  const [isSavingDates, setIsSavingDates] = useState(false);

  const [removeReferralDialogOpen, setRemoveReferralDialogOpen] = useState(false);
  const [selectedReferredForRemove, setSelectedReferredForRemove] = useState<any>(null);
  const [isRemovingReferral, setIsRemovingReferral] = useState(false);

  const [deleteReferralDialogOpen, setDeleteReferralDialogOpen] = useState(false);
  const [selectedReferredForDelete, setSelectedReferredForDelete] = useState<any>(null);
  const [isDeletingReferral, setIsDeletingReferral] = useState(false);

  const [referredProfileDialogOpen, setReferredProfileDialogOpen] = useState(false);
  const [selectedReferredForProfile, setSelectedReferredForProfile] = useState<any>(null);
  const [referredProfileTab, setReferredProfileTab] = useState<'published' | 'saled' | 'paidout'>('published');
  const [referredProfileProducts, setReferredProfileProducts] = useState<any[]>([]);
  const [loadingReferredProfileProducts, setLoadingReferredProfileProducts] = useState(false);

  // Accordion expansível inline de indicados (Estilo PerfilIndicadosPage)
  const [expandedReferredId, setExpandedReferredId] = useState<number | null>(null);
  const [inlineReferredProducts, setInlineReferredProducts] = useState<any[]>([]);
  const [loadingInlineProducts, setLoadingInlineProducts] = useState(false);
  const [inlineProductsTab, setInlineProductsTab] = useState<'published' | 'saled' | 'paied'>('published');

  const [manutencaoDialogOpen, setManutencaoDialogOpen] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState<any>(null);

  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  const [paymentDate, setPaymentDate] = useState("");
  const [isSubmittingPayment, setIsSubmittingPayment] = useState(false);

  const [custosDialogOpen, setCustosDialogOpen] = useState(false);
  const [custosProduto, setCustosProduto] = useState<any>(null);

  const [shippingDialogOpen, setShippingDialogOpen] = useState(false);
  const [shippingCode, setShippingCode] = useState("");
  const [shippingOrderId, setShippingOrderId] = useState<any>(null);
  const [isSubmittingShipping, setIsSubmittingShipping] = useState(false);

  const [retidoDialogOpen, setRetidoDialogOpen] = useState(false);
  const [retidoProduto, setRetidoProduto] = useState<any>(null);

  const [visualizingOutrosCustos, setVisualizingOutrosCustos] = useState(false);
  const [pendingCosts, setPendingCosts] = useState<any[]>([]);
  const [selectedCostIds, setSelectedCostIds] = useState<number[]>([]);

  // Load customer basic info
  useEffect(() => {
    if (id) {
      customerService.getById(id).then(res => {
        if (res.data.success) {
          setCustomer(res.data.data);
        }
      });
    }
  }, [id]);

  const fetchReferrals = async () => {
    setLoadingReferrals(true);
    try {
      const res = await customerService.getReferrals(id!);
      if (res.data.success) {
        setReferrals(res.data.data);
        const initialComm: Record<number, string> = {};
        res.data.data.forEach((r: any) => {
          initialComm[r.id] = r.referred_commission_rate !== undefined ? String(r.referred_commission_rate) : "0";
        });
        setEditingCommissions(initialComm);
      }
    } catch (error) {
      console.error("Erro ao buscar indicações:", error);
      toast.error("Erro ao carregar indicações.");
    } finally {
      setLoadingReferrals(false);
    }
  };

  const handleToggleExpandReferral = async (referredInput: any) => {
    const referredObj = typeof referredInput === 'object' && referredInput !== null
      ? referredInput
      : referrals.find(r => r.id === Number(referredInput));

    const referredId = typeof referredInput === 'object' && referredInput !== null
      ? referredInput.id
      : Number(referredInput);

    if (!referredId) return;

    if (expandedReferredId === referredId) {
      setExpandedReferredId(null);
      setInlineReferredProducts([]);
    } else {
      const initialTab = referredObj && referredObj.is_active === false ? 'saled' : 'published';
      setExpandedReferredId(referredId);
      setInlineReferredProducts([]);
      setInlineProductsTab(initialTab);
      fetchInlineReferredProducts(referredId, initialTab);
    }
  };

  const fetchInlineReferredProducts = async (referredId: number, tab: string) => {
    setLoadingInlineProducts(true);
    try {
      const res = await customerService.getReferralProducts(id!, referredId, { tab, per_page: 50 });
      if (res.data.success) {
        setInlineReferredProducts(res.data.data || []);
        if (res.data.meta?.counts) {
          setReferrals(prev =>
            prev.map(r => (r.id === referredId ? { ...r, ...res.data.meta.counts } : r))
          );
        }
      } else {
        setInlineReferredProducts([]);
      }
    } catch (error) {
      console.error("Erro ao buscar produtos do indicado:", error);
      setInlineReferredProducts([]);
    } finally {
      setLoadingInlineProducts(false);
    }
  };
  const fetchCustomersForSelect = useCallback(async (params: any) => {
    if (!params.search || params.search.trim().length < 2) return [];
    try {
      const res = await customerService.getAll({ search: params.search });
      // Filtrar para evitar que o usuário selecione a si mesmo ou quem já foi indicado
      const items = res.data?.data || res.data || [];
      return items.filter((c: any) =>
        c.id !== Number(id) &&
        c.referred_by_id !== Number(id) &&
        !referrals.some(r => r.id === c.id)
      );
    } catch (err) {
      console.error("Erro ao buscar clientes:", err);
      return [];
    }
  }, [id, referrals]);

  const handleAddReferral = (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedReferredId) return;

    if (selectedReferredCustomer && selectedReferredCustomer.active_indicator_name) {
      setConfirmTransferDialogOpen(true);
      return;
    }

    executeAddReferral();
  };

  const executeAddReferral = async () => {
    if (!selectedReferredId) return;

    setIsSubmittingReferral(true);
    try {
      const response = await customerService.addReferral(id!, Number(selectedReferredId));
      if (response.data.success) {
        toast.success("Indicação vinculada com sucesso!");
        setSelectedReferredId("");
        setSelectedReferredCustomer(null);
        setConfirmTransferDialogOpen(false);
        fetchReferrals();
      }
    } catch (error) {
      console.error("Erro ao vincular indicação:", error);
      toast.error("Erro ao vincular indicação.");
    } finally {
      setIsSubmittingReferral(false);
    }
  };

  // Handlers dos Modais de Indicações
  const handleOpenEditCommissionModal = (referred: any) => {
    setSelectedReferredForEdit(referred);
    setEditingCommissionValue(
      editingCommissions[referred.id] ?? (referred.referred_commission_rate != null ? String(referred.referred_commission_rate) : "")
    );
    setEditCommissionDialogOpen(true);
  };

  const handleConfirmSaveCommission = async () => {
    if (!selectedReferredForEdit) return;
    setIsSavingCommission(true);
    try {
      await api.put(`/api/admin/customers/${id}/referrals/${selectedReferredForEdit.id}/commission`, {
        referred_commission_rate: Number(editingCommissionValue || 0)
      });
      toast.success("Comissão de indicação atualizada com sucesso!");
      setEditCommissionDialogOpen(false);
      await fetchReferrals();
      if (expandedReferredId === selectedReferredForEdit.id) {
        fetchInlineReferredProducts(selectedReferredForEdit.id, inlineProductsTab);
      }
    } catch (error) {
      console.error("Erro ao salvar comissão de indicação:", error);
      toast.error("Erro ao atualizar comissão.");
    } finally {
      setIsSavingCommission(false);
    }
  };

  useEffect(() => {
    api.get("/api/admin/profile").then((res) => {
      const email = res.data?.data?.email || res.data?.email || "";
      setCurrentUserEmail(email.toLowerCase().trim());
    }).catch(() => {});
  }, []);

  const canEditReferralDates = currentUserEmail === "ronald@ronald.com";

  const handleOpenEditDatesModal = (referred: any) => {
    setSelectedReferredForEditDates(referred);
    setEditingStartedAt(referred.started_at ? referred.started_at.substring(0, 16) : "");
    setEditingEndedAt(referred.ended_at ? referred.ended_at.substring(0, 16) : "");
    setEditDatesDialogOpen(true);
  };

  const handleConfirmSaveDates = async () => {
    if (!selectedReferredForEditDates) return;
    setIsSavingDates(true);
    try {
      await customerService.updateReferralDates(id!, selectedReferredForEditDates.id, {
        started_at: editingStartedAt || null,
        ended_at: editingEndedAt || null,
      });
      toast.success("Datas da indicação atualizadas com sucesso!");
      setEditDatesDialogOpen(false);
      await fetchReferrals();
    } catch (error: any) {
      console.error("Erro ao salvar datas da indicação:", error);
      const msg = error.response?.data?.message || "Erro ao atualizar datas.";
      toast.error(msg);
    } finally {
      setIsSavingDates(false);
    }
  };

  const handleOpenRemoveReferralModal = (referred: any) => {
    setSelectedReferredForRemove(referred);
    setRemoveReferralDialogOpen(true);
  };

  const handleConfirmRemoveReferral = async () => {
    if (!selectedReferredForRemove) return;
    setIsRemovingReferral(true);
    try {
      const response = await customerService.removeReferral(id!, selectedReferredForRemove.id, { action: 'unlink' });
      if (response.data.success) {
        toast.success("Indicação desvinculada com sucesso!");
        setRemoveReferralDialogOpen(false);
        fetchReferrals();
      }
    } catch (error) {
      console.error("Erro ao desvincular indicação:", error);
      toast.error("Erro ao desvincular indicação.");
    } finally {
      setIsRemovingReferral(false);
    }
  };

  const handleOpenDeleteReferralModal = (referred: any) => {
    setSelectedReferredForDelete(referred);
    setDeleteReferralDialogOpen(true);
  };

  const handleConfirmDeleteReferral = async () => {
    if (!selectedReferredForDelete) return;
    setIsDeletingReferral(true);
    try {
      const response = await customerService.removeReferral(id!, selectedReferredForDelete.id, { action: 'delete' });
      if (response.data.success) {
        toast.success("Relação de indicação deletada com sucesso!");
        setDeleteReferralDialogOpen(false);
        fetchReferrals();
      }
    } catch (error) {
      console.error("Erro ao deletar relação de indicação:", error);
      toast.error("Erro ao deletar relação de indicação.");
    } finally {
      setIsDeletingReferral(false);
    }
  };

  const fetchReferredProfileProducts = async (referredId: number, tab: string) => {
    setLoadingReferredProfileProducts(true);
    try {
      const res = await api.get(`/api/admin/customers/${id}/referrals/${referredId}/products`, {
        params: { tab, per_page: 50 }
      });
      if (res.data.success) {
        setReferredProfileProducts(res.data.data || []);
        if (res.data.meta?.counts) {
          setSelectedReferredForProfile((prev: any) => prev ? { ...prev, ...res.data.meta.counts } : prev);
        }
      } else {
        setReferredProfileProducts([]);
      }
    } catch (error) {
      console.error("Erro ao buscar produtos do indicado:", error);
      setReferredProfileProducts([]);
    } finally {
      setLoadingReferredProfileProducts(false);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      if (activeTab === "referrals") {
        setPagination({ current_page: 1, last_page: 1, total: 0 });
        if (id) {
          const res = await customerService.getProducts(id, { status: 'published', per_page: 1 });
          if (res.data?.success && res.data?.meta?.counts) {
            setCounts(prev => ({ ...prev, ...res.data.meta.counts }));
          }
        }
        return;
      }

      if (activeTab === "compras") {
        const res = await customerService.getOrders(id!, { page: currentPage, per_page: 16 });
        if (res.data.success) {
          setDataList(res.data.data);
          setPagination(res.data.meta);
          if (res.data.meta.counts) {
            setCounts(prev => ({ ...prev, ...res.data.meta.counts }));
          }
        }
      } else {
        const res = await customerService.getProducts(id!, { status: activeTab, page: currentPage, per_page: 16 });
        if (res.data.success) {
          setDataList(res.data.data);
          setPagination(res.data.meta);
          if (res.data.meta.counts) {
            setCounts(prev => ({ ...prev, ...res.data.meta.counts }));
          }
        }
      }
    } catch (error) {
      console.error("Erro ao buscar dados:", error);
      toast.error("Erro ao carregar dados.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id, activeTab, currentPage]);

  useEffect(() => {
    if (id && activeTab === "referrals") {
      fetchReferrals();
    }
  }, [id, activeTab]);

  const handleTabChange = (val: string) => {
    setSearchParams({ tab: val, page: "1" });
  };

  const handlePageChange = (page: number) => {
    setSearchParams({ tab: activeTab, page: page.toString() });
  };

  const handleAbrirManutencao = (produto: any) => {
    setProdutoSelecionado(produto);
    setManutencaoDialogOpen(true);
  };

  const handleAbrirVerCustos = (produto: any, isOutros: boolean = false) => {
    setCustosProduto(produto);
    setVisualizingOutrosCustos(isOutros);
    setCustosDialogOpen(true);
  };

  const handleAbrirPagamento = async (produto: any) => {
    setProdutoSelecionado(produto);
    const initialDate = produto.paidout_at
      ? new Date(produto.paidout_at).toISOString().split('T')[0]
      : new Date().toISOString().split('T')[0];
    setPaymentDate(initialDate);
    setSelectedCostIds([]);
    setPendingCosts([]);

    try {
      const res = await customerService.getPendingCosts(id!);
      if (res.data.success) {
        let allCosts = res.data.data || [];
        if (produto.paid_maintenance_costs && produto.paid_maintenance_costs.length > 0) {
          const alreadyPaidByThis = produto.paid_maintenance_costs.map((c: any) => ({
            ...c,
            alreadyPaidByThisProduct: true,
          }));
          const existingIds = new Set(allCosts.map((c: any) => c.id));
          alreadyPaidByThis.forEach((c: any) => {
            if (!existingIds.has(c.id)) {
              allCosts.push(c);
            }
          });
        }
        setPendingCosts(allCosts);

        // Pré-selecionar custos do próprio produto e custos já quitados por ele
        const initialSelectedIds = allCosts
          .filter((c: any) => c.product_id === produto.id || c.alreadyPaidByThisProduct)
          .map((c: any) => c.id);
        setSelectedCostIds(initialSelectedIds);
      }
    } catch (error) {
      console.error("Erro ao buscar custos pendentes:", error);
    }

    setPaymentDialogOpen(true);
  };

  const handleConfirmarPagamento = async (clearDate: boolean = false) => {
    const dateToSend = clearDate ? null : paymentDate;
    if (!clearDate && !paymentDate) return;

    setIsSubmittingPayment(true);
    try {
      const response = await customerService.payProduct(id!, produtoSelecionado.id, {
        paidout_at: dateToSend,
        cost_ids: clearDate ? [] : selectedCostIds
      });
      if (response.data.success) {
        toast.success(clearDate ? "Produto retornado para Vendidos!" : "Data de pagamento registrada!");
        setPaymentDialogOpen(false);
        fetchData(); // reload list
      }
    } catch (error: any) {
      console.error("Erro ao registrar pagamento:", error);
      const errorMsg = error.response?.data?.message || "Erro ao registrar pagamento.";
      toast.error(errorMsg);
    } finally {
      setIsSubmittingPayment(false);
    }
  };

  const handleAbrirShipping = (order: any) => {
    setShippingOrderId(order.id);
    setShippingCode(order.shipping_code || "");
    setShippingDialogOpen(true);
  };

  const handleAbrirVerRetido = (produto: any) => {
    setRetidoProduto(produto);
    setRetidoDialogOpen(true);
  };

  const handleConfirmarShipping = async () => {
    setIsSubmittingShipping(true);
    try {
      const response = await api.patch(`/api/admin/orders/${shippingOrderId}/track`, {
        shipping_code: shippingCode
      });
      if (response.data.success) {
        toast.success("Rastreio atualizado com sucesso!");
        setShippingDialogOpen(false);
        fetchData(); // reload list
      }
    } catch (error) {
      console.error("Erro ao registrar rastreio:", error);
      toast.error("Erro ao registrar rastreio.");
    } finally {
      setIsSubmittingShipping(false);
    }
  };

  // Helper para mapear status_id de pedidos
  const getOrderStatus = (status_id: number) => {
    switch (status_id) {
      case 1: return { label: 'Pendente', color: 'bg-yellow-100 text-yellow-700', icon: <Clock className="h-5 w-5 text-yellow-500" /> };
      case 2: return { label: 'Pendente / Não Pago', color: 'bg-blue-100 text-blue-700', icon: <Clock className="h-5 w-5 text-blue-500" /> };
      case 3: return { label: 'Enviado', color: 'bg-purple-100 text-purple-700', icon: <Truck className="h-5 w-5 text-purple-500" /> };
      case 5: return { label: 'Completo', color: 'bg-green-100 text-green-700', icon: <CheckCircle className="h-5 w-5 text-green-500" /> };
      case 7: return { label: 'Cancelado', color: 'bg-red-100 text-red-700', icon: <XCircle className="h-5 w-5 text-red-500" /> };
      case 8: return { label: 'Negado', color: 'bg-red-100 text-red-700', icon: <XCircle className="h-5 w-5 text-red-500" /> };
      case 9: return { label: 'Devolução Cancelada', color: 'bg-gray-100 text-gray-700', icon: <XCircle className="h-5 w-5 text-gray-500" /> };
      case 10: return { label: 'Erro', color: 'bg-red-100 text-red-700', icon: <XCircle className="h-5 w-5 text-red-500" /> };
      case 11: return { label: 'Devolvido', color: 'bg-orange-100 text-orange-700', icon: <XCircle className="h-5 w-5 text-orange-500" /> };
      case 12: return { label: 'Revertido', color: 'bg-orange-100 text-orange-700', icon: <XCircle className="h-5 w-5 text-orange-500" /> };
      case 13: return { label: 'Dinheiro Devolvido', color: 'bg-orange-100 text-orange-700', icon: <XCircle className="h-5 w-5 text-orange-500" /> };
      case 14: return { label: 'Vencido', color: 'bg-red-100 text-red-700', icon: <XCircle className="h-5 w-5 text-red-500" /> };
      case 15: return { label: 'Processado', color: 'bg-blue-100 text-blue-700', icon: <Clock className="h-5 w-5 text-blue-500" /> };
      case 16: return { label: 'Anulado', color: 'bg-red-100 text-red-700', icon: <XCircle className="h-5 w-5 text-red-500" /> };
      case 17: return { label: 'Análise', color: 'bg-yellow-100 text-yellow-700', icon: <Clock className="h-5 w-5 text-yellow-500" /> };
      default: return { label: 'Processando', color: 'bg-gray-100 text-gray-700', icon: <Clock className="h-5 w-5 text-gray-500" /> };
    }
  };

  // Helper para agrupar registros por data formatada
  const groupDataByDate = (items: any[], tab: string) => {
    return items.reduce((acc: Record<string, any[]>, item) => {
      let rawDate = item.created_at;
      let labelPrefix = 'Publicado em';

      if (tab === 'compras') {
        rawDate = item.created_at;
        labelPrefix = 'Comprado em';
      } else if (tab === 'published') {
        rawDate = item.created_at;
        labelPrefix = 'Publicado em';
      } else if (tab === 'saled') {
        rawDate = item.saled_at;
        labelPrefix = 'Vendido em';
      } else if (tab === 'paidout') {
        rawDate = item.paidout_at || item.created_at;
        labelPrefix = 'Pago em';
      } else if (tab === 'returned') {
        rawDate = item.returned_at || item.saled_at || item.created_at;
        labelPrefix = 'Em Trânsito em';
      } else if (tab === 'desistence') {
        rawDate = item.returned_at || item.saled_at || item.created_at;
        labelPrefix = 'Devolvido em';
      }

      const dateFormatted = rawDate ? new Date(rawDate).toLocaleDateString('pt-BR') : 'Sem Data';
      const dateStr = rawDate ? `${labelPrefix} ${dateFormatted}` : 'Sem Data';
      if (!acc[dateStr]) acc[dateStr] = [];
      acc[dateStr].push(item);
      return acc;
    }, {});
  };

  // Renderizar Card do Pedido no modo Visão do Cliente baseado em PerfilPedidosPage.tsx
  const renderUserViewOrderCard = (order: any) => {
    const status = getOrderStatus(order.status_id);
    const subtotalCalc = Number(
      order.subtotal && Number(order.subtotal) > 0
        ? order.subtotal
        : (order.products || []).reduce((sum: number, op: any) => sum + (Number(op.price || 0) * (op.quantity || 1)), 0)
    );
    const hasDiscount = Number(order.discount || 0) > 0;
    const discountVal = Number(order.discount || 0);
    const shippingVal = Number(order.shipping || 0);
    const totalCalc = Number(order.total || (subtotalCalc - discountVal + shippingVal));

    return (
      <div key={order.id} className="border border-gray-200 rounded-lg overflow-hidden bg-white">
        {/* Topo do Pedido */}
        <div className="bg-gray-50 p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 border-b border-gray-200">
          <div>
            <h3 className="text-base font-semibold text-gray-900">
              Pedido #{order.id}
            </h3>
            <p className="text-xs text-gray-500 mt-1">
              Data: {new Date(order.created_at).toLocaleDateString('pt-BR')}
            </p>
          </div>

          <div className="flex items-center gap-2 bg-white px-3 py-1.5 rounded-full border border-gray-200 shadow-sm">
            {status.icon}
            <span className="text-sm font-medium text-gray-700">
              {status.label}
            </span>
          </div>
        </div>

        {/* Lista de Produtos */}
        <div className="p-4">
          <div className="divide-y divide-gray-100">
            {order.products?.map((item: any) => {
              const imgObj = item.product?.images?.[0];
              const imgUrl = typeof imgObj === 'string' ? imgObj : imgObj?.image;
              return (
                <div key={item.id} className="py-3 flex gap-4 first:pt-0 last:pb-0">
                  {imgUrl ? (
                    <div className="h-16 w-16 sm:h-20 sm:w-20 flex-shrink-0 rounded-md border border-gray-200 overflow-hidden">
                      <img
                        src={getImageUrl(imgUrl)}
                        alt={item.product?.name || 'Produto'}
                        className="h-full w-full object-cover"
                      />
                    </div>
                  ) : (
                    <div className="h-16 w-16 sm:h-20 sm:w-20 flex-shrink-0 rounded-md bg-gray-100 flex items-center justify-center">
                      <Package className="h-7 w-7 text-gray-400 opacity-30" />
                    </div>
                  )}
                  <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:justify-between gap-2">
                    <div>
                      <p className="text-sm font-medium text-gray-900 break-words whitespace-normal">
                        {item.product?.name || 'Produto indisponível'} {item.product?.sku ? `(${item.product.sku})` : ''}
                      </p>
                      <p className="text-xs text-gray-500 mt-0.5">Qtd: {item.quantity || 1}</p>
                    </div>
                    <div className="text-left sm:text-right">
                      <p className="text-sm font-semibold text-gray-900">
                        Preço: {formatCurrency(item.price)}
                      </p>
                      {Number(item.shipping_price) > 0 && (
                        <p className="text-xs text-gray-500">
                          Frete do item: {formatCurrency(item.shipping_price)}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Rodapé e Resumo Financeiro */}
        <div className="p-4 border-t border-gray-100 bg-gray-50 flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4">
          {order.shipping_code ? (
            <div className="flex flex-col gap-1">
              <span className="text-xs font-medium text-gray-700">Rastreio dos Correios:</span>
              <span className="text-xs font-semibold text-[#D4C070] font-mono flex items-center gap-1">
                <Truck className="h-3.5 w-3.5" />
                {order.shipping_code}
              </span>
            </div>
          ) : (
            <div className="hidden sm:block"></div>
          )}

          <div className="flex flex-col items-end gap-1 w-full sm:w-auto">
            <div className="text-xs text-gray-500 flex justify-between w-full sm:w-48">
              <span>Subtotal:</span>
              <span>{formatCurrency(subtotalCalc)}</span>
            </div>
            {hasDiscount && (
              <div className="text-xs text-emerald-600 font-medium flex justify-between w-full sm:w-64">
                <span>Desconto {order.discount_code ? `(${order.discount_code})` : ''}:</span>
                <span>- {formatCurrency(discountVal)}</span>
              </div>
            )}
            <div className="text-xs text-gray-500 flex justify-between w-full sm:w-48">
              <span>Frete:</span>
              <span>{formatCurrency(shippingVal)}</span>
            </div>
            <div className="text-sm font-bold text-gray-900 flex justify-between w-full sm:w-48 mt-1 pt-1.5 border-t border-gray-200">
              <span>Total:</span>
              <span className="text-[#849D70]">{formatCurrency(totalCalc)}</span>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Renderizar tabela de Compras
  const renderComprasTable = (orders: any[]) => {
    const grouped = groupDataByDate(orders, 'compras');
    return (
      <div className="space-y-6 p-4">
        {Object.entries(grouped).map(([dateKey, groupOrders]) => (
          <div key={dateKey} className="space-y-3">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-sm border-b border-gray-200 pb-1.5 px-1">
              <Calendar className="h-4 w-4 text-[#D4C070]" />
              <span>{dateKey}</span>
            </div>
            <div className="flex flex-col gap-4">
              {groupOrders.map((order) => {
                if (isUserView) {
                  return renderUserViewOrderCard(order);
                }
                const status = getOrderStatus(order.status_id);
                return (
                  <div key={order.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow p-4">
                    <div className="flex justify-between items-center pb-3 border-b border-gray-100 mb-4">
                      <div>
                        <span className="font-bold text-gray-900 flex items-center gap-2">
                          Pedido #{order.id}
                          <a href={`/vendas/${order.id}`} target="_blank" rel="noopener noreferrer" className="text-[#D4C070] hover:text-[#BCA850] transition-colors" title="Ver Pedido">
                            <Eye className="h-4 w-4" />
                          </a>
                        </span>
                      </div>
                      <Badge variant="outline" className={`border-none ${status.color}`}>
                        {status.label}
                      </Badge>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                      {/* Left: Products */}
                      <div className="flex flex-col gap-3">
                        <h4 className="text-sm font-semibold text-gray-700">Produtos Comprados</h4>
                        <div className="flex flex-col gap-2">
                          {order.products && order.products.map((op: any) => (
                            <div key={op.id} className="flex items-start gap-3 bg-gray-50 p-2 rounded border border-gray-100">
                              {(() => {
                                const imgObj = op.product?.images?.[0];
                                const imgUrl = typeof imgObj === 'string' ? imgObj : imgObj?.image;
                                return imgUrl ? (
                                  <img src={getImageUrl(imgUrl)} alt={op.product?.name} className="w-12 h-12 object-cover rounded bg-white border border-gray-200 shrink-0" />
                                ) : (
                                  <div className="w-12 h-12 bg-white flex items-center justify-center rounded border border-gray-200 text-gray-400 shrink-0">
                                    <Package className="w-6 h-6 opacity-20" />
                                  </div>
                                );
                              })()}
                              <div className="flex-1 min-w-0">
                                <div className="flex items-start justify-between gap-2">
                                  <div className="min-w-0 flex-1">
                                    <p className="text-sm font-medium text-gray-900 break-words leading-tight" title={op.product?.name}>
                                      {op.product?.name || 'Produto Excluído'}
                                    </p>
                                    {op.product?.sku && (
                                      <p className="text-xs text-gray-500 font-mono mt-0.5">
                                        Ref (SKU): {op.product.sku}
                                      </p>
                                    )}
                                  </div>
                                  {op.product?.id && (
                                    <a
                                      href={`/editar-produto/${op.product.id}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-[#D4C070] hover:text-[#BCA850] transition-colors flex-shrink-0 p-0.5"
                                      title="Ver / Editar Produto no Admin"
                                    >
                                      <Eye className="h-4 w-4" />
                                    </a>
                                  )}
                                </div>
                                <p className="text-xs text-gray-500 mt-1">
                                  {op.quantity}x - R$ {Number(op.price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      {/* Right: Payment and Totals */}
                      <div className="flex flex-col gap-4 lg:pl-6 lg:border-l lg:border-gray-100">
                        <div>
                          <h4 className="text-sm font-semibold text-gray-700 mb-2">Forma de Pagamento</h4>
                          <div className="bg-gray-50 p-3 rounded border border-gray-100 text-sm text-[#68686A] space-y-1.5">
                            {order.payment1 ? (
                              <div className="flex justify-between items-center text-xs">
                                <span className="font-medium text-gray-700">
                                  Pagamento 1 {order.payment_type?.['payment1'] ? `(${order.payment_type['payment1']})` : order.payment_type?.['payment1.type'] ? `(${order.payment_type['payment1.type']})` : ''}
                                </span>
                                <span className="font-semibold text-gray-900">
                                  R$ {Number(order.payment1).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                              </div>
                            ) : null}
                            {order.payment2 ? (
                              <div className="flex justify-between items-center text-xs">
                                <span className="font-medium text-gray-700">
                                  Pagamento 2 {order.payment_type?.['payment2'] ? `(${order.payment_type['payment2']})` : order.payment_type?.['payment2.type'] ? `(${order.payment_type['payment2.type']})` : ''}
                                </span>
                                <span className="font-semibold text-gray-900">
                                  R$ {Number(order.payment2).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                              </div>
                            ) : null}
                            {order.payment3 ? (
                              <div className="flex justify-between items-center text-xs">
                                <span className="font-medium text-gray-700">
                                  Pagamento 3 {order.payment_type?.['payment3'] ? `(${order.payment_type['payment3']})` : order.payment_type?.['payment3.type'] ? `(${order.payment_type['payment3.type']})` : ''}
                                </span>
                                <span className="font-semibold text-gray-900">
                                  R$ {Number(order.payment3).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                              </div>
                            ) : null}
                            {order.payment4 ? (
                              <div className="flex justify-between items-center text-xs">
                                <span className="font-medium text-gray-700">
                                  Pagamento 4 {order.payment_type?.['payment4'] ? `(${order.payment_type['payment4']})` : order.payment_type?.['payment4.type'] ? `(${order.payment_type['payment4.type']})` : ''}
                                </span>
                                <span className="font-semibold text-gray-900">
                                  R$ {Number(order.payment4).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </span>
                              </div>
                            ) : null}

                            {!order.payment1 && !order.payment2 && !order.payment3 && !order.payment4 && (
                              <p className="font-medium text-gray-900">
                                {order.gateway || order.payment_info?.method || order.payment_info?.profile || order.payment_info?.name || 'Desconhecido'}
                              </p>
                            )}
                          </div>
                        </div>

                        <div className="flex flex-col gap-1 mt-auto bg-[#849D70]/5 p-3 rounded">
                          <div className="flex justify-between text-sm text-gray-600">
                            <span>Subtotal:</span>
                            <span>
                              R$ {Number(
                                order.subtotal && Number(order.subtotal) > 0
                                  ? order.subtotal
                                  : (order.products || []).reduce((sum: number, op: any) => sum + (Number(op.price || 0) * (op.quantity || 1)), 0)
                              ).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </span>
                          </div>
                          {Number(order.discount || 0) > 0 ? (
                            <div className="flex justify-between text-sm text-emerald-600 font-medium">
                              <span>Desconto {order.discount_code ? `(${order.discount_code})` : ''}:</span>
                              <span>- R$ {Number(order.discount).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                          ) : null}
                          <div className="flex justify-between text-sm text-gray-600">
                            <span>Frete:</span>
                            <span>R$ {Number(order.shipping || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </div>
                          <div className="flex justify-between items-center text-sm text-gray-600">
                            <span>Rastreio:</span>
                            <span className="flex items-center gap-1">
                              <span className="font-mono text-xs">{order.shipping_code || '-'}</span>
                              <button
                                onClick={() => handleAbrirShipping(order)}
                                title="Informar Rastreio"
                                className="cursor-pointer text-[#D4C070] hover:text-[#BCA850] transition-colors flex items-center"
                              >
                                <Edit3 className="h-3.5 w-3.5" />
                              </button>
                            </span>
                          </div>
                          <div className="flex justify-between font-bold text-gray-900 border-t border-[#849D70]/20 pt-2 mt-1 text-base">
                            <span>Total:</span>
                            <span className="text-[#849D70]">R$ {Number(order.total || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Helper base para renderizar o Card do Produto
  const renderProductCard = (product: any, extraInfo: React.ReactNode, actionTopRight?: React.ReactNode, actionBottom?: React.ReactNode) => (
    <div key={product.id} className="relative flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow p-4">
      {actionTopRight && (
        <div className="absolute top-3 right-3">
          {actionTopRight}
        </div>
      )}
      <div className="flex items-center gap-3 pr-8">
        {product.image ? (
          <img src={product.image} alt={product.name} className="w-14 h-14 sm:w-16 sm:h-16 object-cover rounded bg-white border border-gray-200 shrink-0" />
        ) : (
          <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gray-50 flex items-center justify-center rounded border border-gray-200 text-gray-400 shrink-0">
            <Package className="w-6 h-6 opacity-20" />
          </div>
        )}
        <div className="flex-1 min-w-0">
          <h3 className="font-medium text-gray-900 break-words line-clamp-2 text-base" title={product.name}>{product.name}</h3>
          <p className="text-sm text-[#68686A]">SKU: {product.sku}</p>
        </div>
      </div>

      <div className="flex-1 flex flex-col mt-3">
        {extraInfo}
      </div>

      {actionBottom && (
        <div className="mt-3 pt-3 border-t border-gray-100">
          {actionBottom}
        </div>
      )}
    </div>
  );

  // Helper para renderizar o Card exatamente como o Usuário/Cliente enxerga no extrato da Loja
  const renderUserViewCard = (product: any, tab: string) => {
    const totalCustosAtivos = Number(product.total_active_maintenance_costs || 0);
    const totalOutrosCustos = Number(product.total_other_costs_paid || 0);

    const hasActiveCosts = totalCustosAtivos > 0;
    const hasPaidCosts = totalOutrosCustos > 0;
    const hasDeductions = hasActiveCosts || hasPaidCosts;

    const repasseLiquido = product.repasse_liquido ?? (
      Number(product.supplier_value || 0) - totalCustosAtivos - totalOutrosCustos
    );

    return (
      <div key={product.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow flex flex-col p-4">
        {/* Corpo do Card */}
        <div className="flex-1 flex flex-col gap-4">
          {/* Dados do Produto */}
          <div className="flex items-start gap-3">
            {product.image ? (
              <img
                src={product.image}
                alt={product.name}
                className="w-16 h-16 object-cover rounded bg-white border border-gray-200 shrink-0"
              />
            ) : (
              <div className="w-16 h-16 bg-gray-50 flex items-center justify-center rounded border border-gray-200 text-gray-400 shrink-0">
                <Package className="w-7 h-7 opacity-20" />
              </div>
            )}
            <div className="flex-1 min-w-0">
              <h3 className="font-semibold text-gray-900 text-base break-words line-clamp-2" title={product.name}>
                {product.name}
              </h3>
              <p className="text-xs text-gray-500 font-mono mt-0.5">Ref (SKU): {product.sku || '-'}</p>
            </div>
          </div>

          {/* Bloco Financeiro e Repasse */}
          {tab !== 'returned' && tab !== 'desistence' && (
            <div className="mt-auto">
              {tab === 'saled' ? (
                <div className="bg-gray-50 p-3.5 rounded-lg border border-gray-200 text-xs space-y-2">
                  <div className="flex flex-wrap justify-between items-center gap-1 text-gray-600">
                    <span>Vendido em:</span>
                    <span className="font-semibold text-gray-900">{product.saled_at ? new Date(product.saled_at).toLocaleDateString('pt-BR') : '-'}</span>
                  </div>
                  <div className="flex flex-wrap justify-between items-center gap-1 text-gray-600">
                    <span>Você Receberá em:</span>
                    <span className="font-semibold text-gray-900">{product.max_receipt_date ? new Date(product.max_receipt_date).toLocaleDateString('pt-BR') : 'A calcular'}</span>
                  </div>

                  {hasDeductions && (
                    <>
                      <div className="flex flex-wrap justify-between items-center gap-1 text-gray-600 pt-1.5 border-t border-gray-200/60">
                        <span>Repasse Bruto:</span>
                        <span className="font-semibold text-gray-900">{formatCurrency(product.supplier_value)}</span>
                      </div>

                      {hasActiveCosts && (
                        <div className="flex flex-wrap justify-between items-center gap-1 text-orange-700">
                          <span className="flex items-center gap-1 flex-wrap">
                            Custos de Manutenção:
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAbrirVerCustos(product, false);
                              }}
                              className="text-orange-700 hover:text-orange-950 transition-colors inline-flex items-center cursor-pointer"
                              title="Ver Detalhes dos Custos de Manutenção"
                            >
                              <Info className="h-3.5 w-3.5 ml-0.5" />
                            </button>
                          </span>
                          <span className="font-semibold shrink-0">- {formatCurrency(totalCustosAtivos)}</span>
                        </div>
                      )}

                      {hasPaidCosts && (
                        <div className="flex flex-wrap justify-between items-center gap-1 text-orange-700">
                          <span className="flex items-center gap-1 flex-wrap">
                            Custos Quitados de Outras Peças:
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleAbrirVerCustos(product, true);
                              }}
                              className="text-orange-700 hover:text-orange-950 transition-colors inline-flex items-center cursor-pointer"
                              title="Ver Detalhes dos Custos Quitados"
                            >
                              <Info className="h-3.5 w-3.5 ml-0.5" />
                            </button>
                          </span>
                          <span className="font-semibold shrink-0">- {formatCurrency(totalOutrosCustos)}</span>
                        </div>
                      )}
                    </>
                  )}

                  <div className="flex flex-wrap justify-between items-center gap-1 pt-2 font-bold text-sm text-gray-900 border-t border-gray-200">
                    <span className="text-gray-700">Valor à receber:</span>
                    <span className="text-[#849D70] text-base shrink-0">{formatCurrency(repasseLiquido)}</span>
                  </div>
                </div>
              ) : hasDeductions ? (
                <div className="bg-gray-50 p-3.5 rounded-lg border border-gray-200 text-xs space-y-2">
                  <div className="flex flex-wrap justify-between items-center gap-1 text-gray-600 pb-1.5 border-b border-gray-200/60">
                    <span>Repasse Bruto:</span>
                    <span className="font-semibold text-gray-900">{formatCurrency(product.supplier_value)}</span>
                  </div>

                  {hasActiveCosts && (
                    <div className="flex flex-wrap justify-between items-center gap-1 text-orange-700">
                      <span className="flex items-center gap-1 flex-wrap">
                        Custos de Manutenção:
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAbrirVerCustos(product, false);
                          }}
                          className="text-orange-700 hover:text-orange-950 transition-colors inline-flex items-center cursor-pointer"
                          title="Ver Detalhes dos Custos de Manutenção"
                        >
                          <Info className="h-3.5 w-3.5 ml-0.5" />
                        </button>
                      </span>
                      <span className="font-semibold shrink-0">- {formatCurrency(totalCustosAtivos)}</span>
                    </div>
                  )}

                  {hasPaidCosts && (
                    <div className="flex flex-wrap justify-between items-center gap-1 text-orange-700">
                      <span className="flex items-center gap-1 flex-wrap">
                        Custos Quitados de Outras Peças:
                        <button
                          type="button"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleAbrirVerCustos(product, true);
                          }}
                          className="text-orange-700 hover:text-orange-950 transition-colors inline-flex items-center cursor-pointer"
                          title="Ver Detalhes dos Custos Quitados"
                        >
                          <Info className="h-3.5 w-3.5 ml-0.5" />
                        </button>
                      </span>
                      <span className="font-semibold shrink-0">- {formatCurrency(totalOutrosCustos)}</span>
                    </div>
                  )}

                  <div className="flex flex-wrap justify-between items-center gap-1 pt-2 font-bold text-sm text-gray-900 border-t border-gray-200">
                    <span className="text-gray-700 break-words">
                      {tab === 'published' ? 'Valor à receber após a venda:' :
                        tab === 'paidout' ? 'Valor recebido:' : 'Repasse Líquido:'}
                    </span>
                    <span className="text-[#849D70] text-base shrink-0">{formatCurrency(repasseLiquido)}</span>
                  </div>
                </div>
              ) : (
                <div className="bg-[#849D70]/5 p-3 rounded-lg border border-[#849D70]/10 flex flex-wrap justify-between items-center gap-2">
                  <span className="font-medium text-gray-700 text-xs sm:text-sm break-words">
                    {tab === 'published' ? 'Valor à receber após a venda:' :
                      tab === 'paidout' ? 'Valor recebido:' : 'Repasse Previsto:'}
                  </span>
                  <span className="font-bold text-[#849D70] text-base sm:text-lg shrink-0">
                    {formatCurrency(repasseLiquido)}
                  </span>
                </div>
              )}
            </div>
          )}
        </div>

        {/* Rodapé de Data para Recebidos */}
        {tab === 'paidout' && (
          <div className="bg-gray-50/80 px-4 py-2.5 mt-3 border-t border-gray-100 flex items-center justify-between text-xs text-gray-600 rounded-b">
            <span className="flex items-center gap-1.5">
              <Calendar className="h-3.5 w-3.5 text-[#849D70]" />
              Pago em:
            </span>
            <span className="font-semibold text-gray-900">
              {product.paidout_at ? new Date(product.paidout_at).toLocaleDateString('pt-BR') : '-'}
            </span>
          </div>
        )}
      </div>
    );
  };

  // Renderizar Cards de Publicados
  const renderPublicadosTable = (products: any[]) => {
    const grouped = groupDataByDate(products, 'published');
    return (
      <div className="space-y-6 p-4">
        {Object.entries(grouped).map(([dateKey, groupProducts]) => (
          <div key={dateKey} className="space-y-3">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-sm border-b border-gray-200 pb-1.5 px-1">
              <Calendar className="h-4 w-4 text-[#D4C070]" />
              <span>{dateKey}</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {groupProducts.map(product => {
                if (isUserView) {
                  return renderUserViewCard(product, 'published');
                }
                const custos = product.maintenance_costs || [];
                const totalCustos = product.total_active_maintenance_costs || 0;
                const hasCustos = custos.length > 0;

                return renderProductCard(
                  product,
                  <div className="flex flex-col text-xs text-gray-500 gap-1 mt-2">
                    <div className="bg-gray-50/50 p-2.5 rounded border border-gray-100 flex flex-col gap-1">
                      {product.sale_price > 0 ? (
                        <>
                          <p className="line-through decoration-red-400">Original: R$ {Number(product.base_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          <p className="font-medium text-gray-900">Promoção: R$ {Number(product.sale_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        </>
                      ) : (
                        <p className="font-medium text-gray-700">Preço: R$ {Number(product.base_price || product.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      )}
                      {product.certificate_price > 0 && (
                        <p>Certificado: R$ {Number(product.certificate_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      )}
                      <p>Juros: R$ {Number(product.juros || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      <p>Frete: R$ {Number(product.shipping_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (não incluso no total)</p>
                    </div>

                    <div className="bg-[#849D70]/5 p-2.5 rounded mt-1">
                      <p className="font-medium text-[#849D70] text-sm mb-1">
                        Total À Vista: R$ {Number(product.total_avista || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                      <p className="font-semibold text-gray-900 text-sm">
                        Total Parcelado: R$ {Number(product.total_parcelado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                      </p>
                    </div>
                    {hasCustos && (
                      <div className="flex justify-between items-center bg-orange-50 p-2 rounded text-orange-800 mt-1">
                        <span>Custos Manutenção ({custos.length}):</span>
                        <span className="flex items-center gap-1 font-medium">
                          <span>- R$ {totalCustos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                          <button
                            onClick={() => handleAbrirVerCustos(product, false)}
                            title="Ver Detalhes"
                            className="flex items-center cursor-pointer text-orange-800 hover:text-orange-950 transition-colors"
                          >
                            <Eye className="h-3.5 w-3.5" />
                          </button>
                        </span>
                      </div>
                    )}
                  </div>,
                  <div className="flex gap-2">
                    <Button
                      size="icon"
                      variant="ghost"
                      className="h-8 w-8 text-[#D4C070] hover:text-[#b8a65c] hover:bg-[#D4C070]/10"
                      onClick={() => window.open(`/editar-produto/${product.id}`, '_blank')}
                      title="Editar Produto"
                    >
                      <Edit3 className="h-5 w-5" />
                    </Button>
                    <Button
                      size="icon"
                      variant="ghost"
                      className="h-8 w-8 text-[#D4C070] hover:text-[#b8a65c] hover:bg-[#D4C070]/10"
                      onClick={() => window.open(`${import.meta.env.VITE_STORE_URL}/produtos/${product.slug}`, '_blank')}
                      title="Ver na Loja"
                    >
                      <Eye className="h-5 w-5" />
                    </Button>
                  </div>,
                  <div className="flex flex-col sm:flex-row gap-2 mt-2">
                    <Button
                      size="sm"
                      variant="outline"
                      className="w-full text-[#D4C070] border-[#D4C070] hover:bg-[#D4C070] hover:text-white"
                      onClick={() => handleAbrirManutencao(product)}
                    >
                      <Wrench className="h-4 w-4 mr-2" />
                      {hasCustos ? 'Gerenciar Custos' : 'Custos'}
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Renderizar Cards de Vendidos
  const renderVendidosTable = (products: any[]) => {
    const grouped = groupDataByDate(products, 'saled');
    return (
      <div className="space-y-6 p-4">
        {Object.entries(grouped).map(([dateKey, groupProducts]) => (
          <div key={dateKey} className="space-y-3">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-sm border-b border-gray-200 pb-1.5 px-1">
              <Calendar className="h-4 w-4 text-[#D4C070]" />
              <span>{dateKey}</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {groupProducts.map(product => {
                if (isUserView) {
                  return renderUserViewCard(product, 'saled');
                }
                const custos = product.maintenance_costs || [];
                const totalCustos = product.total_active_maintenance_costs || 0;
                const referralCost = Number(product.referral_commission_cost || 0);
                const valorFinal = Number(product.supplier_value) - totalCustos;
                const hasCustos = custos.length > 0;
                const hasReferralCost = referralCost > 0;

                return renderProductCard(
                  product,
                  <div className="flex flex-col text-xs text-gray-500 gap-2 mt-2">
                    <div className="flex justify-between items-center pb-2 border-b border-gray-50">
                      <span className="text-gray-500 font-medium">Vendido em:</span>
                      <div className="flex items-center gap-2">
                        <span>{product.saled_at ? new Date(product.saled_at).toLocaleDateString('pt-BR') : '-'}</span>
                        {product.order_id && (
                          <Badge
                            variant="outline"
                            className="flex items-center gap-1 font-mono cursor-pointer hover:bg-gray-50 border-gray-200 text-[#D4C070]"
                            onClick={() => window.open(`/vendas/${product.order_id}`, '_blank')}
                            title="Ver Pedido"
                          >
                            #{product.order_id} <Eye className="h-3 w-3" />
                          </Badge>
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
                      <div className="bg-gray-50/50 p-2 rounded border border-gray-100 flex flex-col justify-center gap-1">
                        {product.sale_price > 0 ? (
                          <>
                            <p className="line-through decoration-red-400">Original: R$ {Number(product.base_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            <p className="font-medium text-gray-900">Promoção: R$ {Number(product.sale_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          </>
                        ) : (
                          <p className="font-medium text-gray-700">Preço: R$ {Number(product.base_price || product.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        )}
                        {product.certificate_price > 0 && (
                          <p>Certificado: R$ {Number(product.certificate_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        )}
                        <p>Juros: R$ {Number(product.juros || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        <p>Frete: R$ {Number(product.shipping_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="bg-[#849D70]/5 p-2 rounded">
                          <p className="font-medium text-[#849D70] mb-0.5">
                            À Vista: R$ {Number(product.total_avista || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                          <p className="font-semibold text-gray-900">
                            Parcelado: R$ {Number(product.total_parcelado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                        </div>
                        <div className="border border-gray-100 rounded p-2 bg-white">
                          <div className="flex justify-between mb-0.5">
                            <span className="text-gray-500">Regra de Comissão:</span>
                            <span className="text-gray-700 font-medium">{product.fdc_comission_rule} ({product.fdc_comission_percent}%)</span>
                          </div>
                          <div className="flex justify-between items-center mb-0.5">
                            <span className="text-gray-500">Valor Retido FDC:</span>
                            <span className="flex items-center gap-1">
                              <span className="text-gray-900">R$ {Number(product.fdc_comission_value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                              <button
                                onClick={() => handleAbrirVerRetido(product)}
                                title="Ver Detalhes"
                                className="flex items-center cursor-pointer text-[#D4C070] hover:text-[#BCA850] transition-colors"
                              >
                                <Eye className="h-4 w-4" />
                              </button>
                            </span>
                          </div>
                          {hasCustos && (
                            <div className="flex justify-between items-center mb-0.5">
                              <span className="text-gray-500">Custos Manutenção:</span>
                              <span className="flex items-center gap-1">
                                <span className="text-orange-600">- R$ {totalCustos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                <button
                                  onClick={() => handleAbrirVerCustos(product, false)}
                                  title="Ver Detalhes"
                                  className="flex items-center cursor-pointer"
                                >
                                  <Eye className="h-3.5 w-3.5 text-[#D4C070] hover:text-[#BCA850] transition-colors" />
                                </button>
                              </span>
                            </div>
                          )}
                          {hasReferralCost && (
                            <div className="flex justify-between items-center text-purple-700">
                              <span className="text-gray-500">Comissão de Indicação (FDC):</span>
                              <span className="font-medium text-purple-700">R$ {referralCost.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between items-center text-xs text-gray-600 pt-2 mt-1 border-t border-gray-100">
                      <span className="flex items-center gap-1.5 font-medium">
                        <Calendar className="h-3.5 w-3.5 text-[#D4C070]" />
                        Data Prevista de Repasse:
                      </span>
                      <span className="font-semibold text-gray-900">
                        {product.max_receipt_date
                          ? new Date(product.max_receipt_date).toLocaleDateString('pt-BR')
                          : 'A calcular'}
                      </span>
                    </div>

                    <div className="flex justify-between font-bold text-sm pt-2 mt-1 border-t border-gray-50">
                      <span className="text-gray-700 mt-1">
                        A Receber (calculado sobre o{' '}
                        <span
                          title={`Preço Base: R$ ${Number(product.base_price || product.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
                          className="underline decoration-dotted cursor-help"
                        >
                          preço
                        </span>
                        ):
                      </span>
                      <span className="text-[#849D70] text-base">R$ {valorFinal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>,
                  null, // actionTopRight
                  <div className="flex flex-col sm:flex-row gap-2 mt-2">
                    <Button
                      size="sm"
                      variant="outline"
                      className="w-full sm:w-1/2 text-[#D4C070] border-[#D4C070] hover:bg-[#D4C070] hover:text-white"
                      onClick={() => handleAbrirManutencao(product)}
                    >
                      <Wrench className="h-4 w-4 mr-2" />
                      {hasCustos ? 'Gerenciar Custos' : 'Custos'}
                    </Button>
                    <Button
                      size="sm"
                      className="w-full sm:w-1/2 bg-[#849D70] text-white hover:bg-[#728860]"
                      onClick={() => handleAbrirPagamento(product)}
                    >
                      <DollarSign className="h-4 w-4 mr-2" />
                      Pagar
                    </Button>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Renderizar Cards de Recebidos
  const renderRecebidosTable = (products: any[]) => {
    const grouped = groupDataByDate(products, 'paidout');
    return (
      <div className="space-y-6 p-4">
        {Object.entries(grouped).map(([dateKey, groupProducts]) => {
          const groupTotalRepasse = groupProducts.reduce(
            (sum, p) => sum + Number(p.repasse_liquido || 0),
            0
          );

          return (
            <div key={dateKey} className="space-y-3">
              <div className="flex items-center justify-between font-bold text-gray-800 text-sm border-b border-gray-200 pb-1.5 px-1">
                <div className="flex items-center gap-2">
                  <Calendar className="h-4 w-4 text-[#D4C070]" />
                  <span>{dateKey}</span>
                </div>
                <div className="text-gray-600 font-semibold text-xs sm:text-sm">
                  Total: <span className="font-bold text-[#849D70]">{formatCurrency(groupTotalRepasse)}</span>
                </div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {groupProducts.map(product => {
                  if (isUserView) {
                    return renderUserViewCard(product, 'paidout');
                  }
                  const custos = product.maintenance_costs || [];
                  const totalCustosAtivos = product.total_active_maintenance_costs || 0;
                  const totalOutrosCustos = product.total_other_costs_paid || 0;
                  const referralCost = Number(product.referral_commission_cost || 0);
                  const valorFinal = Number(product.supplier_value) - totalCustosAtivos - totalOutrosCustos;

                  const hasCustos = custos.length > 0;
                  const paidOtherCosts = product.paid_maintenance_costs || [];
                  const hasPaidOtherCosts = paidOtherCosts.length > 0;
                  const hasReferralCost = referralCost > 0;

                  return renderProductCard(
                    product,
                    <div className="flex flex-col text-xs text-gray-500 gap-2 mt-2">
                      <div className="flex justify-between items-center pb-2 border-b border-gray-50">
                        <span className="text-gray-500 font-medium">Pago em:</span>
                        <div className="flex items-center gap-2">
                          <span className="font-medium text-[#849D70] flex items-center gap-1">
                            {product.paidout_at ? new Date(product.paidout_at).toLocaleDateString('pt-BR') : '-'}
                            <button
                              onClick={() => handleAbrirPagamento(product)}
                              title="Editar Data ou Retornar para Vendidos"
                              className="flex items-center cursor-pointer"
                            >
                              <Edit3 className="h-3.5 w-3.5 text-[#D4C070] hover:text-[#BCA850] transition-colors" />
                            </button>
                          </span>
                          {product.order_id && (
                            <Badge
                              variant="outline"
                              className="flex items-center gap-1 font-mono cursor-pointer hover:bg-gray-50 border-gray-200 text-[#D4C070]"
                              onClick={() => window.open(`/vendas/${product.order_id}`, '_blank')}
                              title="Ver Pedido"
                            >
                              #{product.order_id} <Eye className="h-3 w-3" />
                            </Badge>
                          )}
                        </div>
                      </div>

                      <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
                        <div className="bg-gray-50/50 p-2 rounded border border-gray-100 flex flex-col justify-center gap-1">
                          {product.sale_price > 0 ? (
                            <>
                              <p className="line-through decoration-red-400">Original: R$ {Number(product.base_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                              <p className="font-medium text-gray-900">Promoção: R$ {Number(product.sale_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            </>
                          ) : (
                            <p className="font-medium text-gray-700">Preço: R$ {Number(product.base_price || product.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          )}
                          {product.certificate_price > 0 && (
                            <p>Certificado: R$ {Number(product.certificate_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          )}
                          <p>Juros: R$ {Number(product.juros || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          <p>Frete: R$ {Number(product.shipping_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        </div>

                        <div className="flex flex-col gap-2">
                          <div className="bg-[#849D70]/5 p-2 rounded">
                            <p className="font-medium text-[#849D70] mb-0.5">
                              À Vista: R$ {Number(product.total_avista || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                            <p className="font-semibold text-gray-900">
                              Parcelado: R$ {Number(product.total_parcelado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                            </p>
                          </div>
                          <div className="border border-gray-100 rounded p-2 bg-white">
                            <div className="flex justify-between mb-0.5">
                              <span className="text-gray-500">Regra de Comissão:</span>
                              <span className="text-gray-700 font-medium">{product.fdc_comission_rule} ({product.fdc_comission_percent}%)</span>
                            </div>
                            <div className="flex justify-between items-center mb-0.5">
                              <span className="text-gray-500">Valor Retido FDC:</span>
                              <span className="flex items-center gap-1">
                                <span className="text-gray-900">R$ {Number(product.fdc_comission_value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                <button
                                  onClick={() => handleAbrirVerRetido(product)}
                                  title="Ver Detalhes"
                                  className="flex items-center cursor-pointer text-[#D4C070] hover:text-[#BCA850] transition-colors"
                                >
                                  <Eye className="h-4 w-4" />
                                </button>
                              </span>
                            </div>
                            {hasCustos && (
                              <div className="flex justify-between items-center mb-0.5">
                                <span className="text-gray-500">Custos Manutenção:</span>
                                <span className="flex items-center gap-1">
                                  <span className="text-orange-600">- R$ {totalCustosAtivos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                  <button
                                    onClick={() => handleAbrirVerCustos(product, false)}
                                    title="Ver Detalhes"
                                    className="flex items-center cursor-pointer"
                                  >
                                    <Eye className="h-3.5 w-3.5 text-[#D4C070] hover:text-[#BCA850] transition-colors" />
                                  </button>
                                </span>
                              </div>
                            )}
                            {hasPaidOtherCosts && (
                              <div className="flex justify-between items-center mb-0.5">
                                <span className="text-gray-500">Custos de Manutenção Quitados:</span>
                                <span className="flex items-center gap-1">
                                  <span className="text-orange-600">- R$ {totalOutrosCustos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                  <button
                                    onClick={() => handleAbrirVerCustos(product, true)}
                                    title="Ver Detalhes"
                                    className="flex items-center cursor-pointer"
                                  >
                                    <Eye className="h-3.5 w-3.5 text-[#D4C070] hover:text-[#BCA850] transition-colors" />
                                  </button>
                                </span>
                              </div>
                            )}
                            {hasReferralCost && (
                              <div className="flex justify-between items-center text-purple-700">
                                <span className="text-gray-500">Comissão de Indicação (FDC):</span>
                                <span className="font-medium text-purple-700">R$ {referralCost.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="flex justify-between font-bold text-sm pt-2 mt-1 border-t border-gray-50">
                        <span className="text-gray-700 mt-1">Valor Recebido:</span>
                        <span className="text-[#849D70] text-base">R$ {valorFinal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    );
  };

  // Renderizar Cards de Devolvidos
  const renderDevolvidosTable = (products: any[]) => {
    const grouped = groupDataByDate(products, 'returned');
    return (
      <div className="space-y-6 p-4">
        {Object.entries(grouped).map(([dateKey, groupProducts]) => (
          <div key={dateKey} className="space-y-3">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-sm border-b border-gray-200 pb-1.5 px-1">
              <Calendar className="h-4 w-4 text-[#D4C070]" />
              <span>{dateKey}</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {groupProducts.map(product => {
                if (isUserView) {
                  return renderUserViewCard(product, 'returned');
                }
                const custos = product.maintenance_costs || [];
                const totalCustos = product.total_active_maintenance_costs || 0;
                const valorFinal = Number(product.supplier_value) - totalCustos;
                const hasCustos = custos.length > 0;

                return renderProductCard(
                  product,
                  <div className="flex flex-col text-xs text-gray-500 gap-2 mt-2">
                    <div className="flex justify-between items-center pb-2 border-b border-gray-50">
                      <span className="text-gray-500 font-medium">Em Trânsito em:</span>
                      <span className="text-red-600 font-medium">{product.returned_at ? new Date(product.returned_at).toLocaleDateString('pt-BR') : '-'}</span>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
                      <div className="bg-gray-50/50 p-2 rounded border border-gray-100 flex flex-col justify-center gap-1">
                        {product.sale_price > 0 ? (
                          <>
                            <p className="line-through decoration-red-400">Original: R$ {Number(product.base_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            <p className="font-medium text-gray-900">Promoção: R$ {Number(product.sale_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          </>
                        ) : (
                          <p className="font-medium text-gray-700">Preço: R$ {Number(product.base_price || product.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        )}
                        {product.certificate_price > 0 && (
                          <p>Certificado: R$ {Number(product.certificate_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        )}
                        <p>Juros: R$ {Number(product.juros || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        <p>Frete: R$ {Number(product.shipping_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="bg-[#849D70]/5 p-2 rounded">
                          <p className="font-medium text-[#849D70] mb-0.5">
                            À Vista: R$ {Number(product.total_avista || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                          <p className="font-semibold text-gray-900">
                            Parcelado: R$ {Number(product.total_parcelado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                        </div>
                        <div className="border border-gray-100 rounded p-2 bg-white">
                          <div className="flex justify-between mb-0.5">
                            <span className="text-gray-500">Regra de Comissão:</span>
                            <span className="text-gray-700 font-medium">{product.fdc_comission_rule} ({product.fdc_comission_percent}%)</span>
                          </div>
                          <div className="flex justify-between items-center mb-0.5">
                            <span className="text-gray-500">Valor Retido FDC:</span>
                            <span className="flex items-center gap-1">
                              <span className="text-gray-900">- R$ {Number(product.fdc_comission_value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                              <button
                                onClick={() => handleAbrirVerRetido(product)}
                                title="Ver Detalhes"
                                className="flex items-center cursor-pointer text-[#D4C070] hover:text-[#BCA850] transition-colors"
                              >
                                <Eye className="h-4 w-4" />
                              </button>
                            </span>
                          </div>
                          {hasCustos && (
                            <div className="flex justify-between items-center">
                              <span className="text-gray-500">Custos Manutenção:</span>
                              <span className="flex items-center gap-1">
                                <span className="text-orange-600">- R$ {totalCustos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                <button
                                  onClick={() => handleAbrirVerCustos(product, false)}
                                  title="Ver Detalhes"
                                  className="flex items-center cursor-pointer"
                                >
                                  <Eye className="h-3.5 w-3.5 text-[#D4C070] hover:text-[#BCA850] transition-colors" />
                                </button>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between font-bold text-sm pt-2 mt-1 border-t border-gray-50">
                      <span className="text-gray-700 mt-1">Repasse Previsto:</span>
                      <span className="text-gray-400 text-base line-through">R$ {valorFinal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Renderizar Cards de Desistências de Venda
  const renderDesistenciaTable = (products: any[]) => {
    const grouped = groupDataByDate(products, 'desistence');
    return (
      <div className="space-y-6 p-4">
        {Object.entries(grouped).map(([dateKey, groupProducts]) => (
          <div key={dateKey} className="space-y-3">
            <div className="flex items-center gap-2 font-bold text-gray-800 text-sm border-b border-gray-200 pb-1.5 px-1">
              <Calendar className="h-4 w-4 text-[#D4C070]" />
              <span>{dateKey}</span>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
              {groupProducts.map(product => {
                if (isUserView) {
                  return renderUserViewCard(product, 'desistence');
                }
                const custos = product.maintenance_costs || [];
                const totalCustos = product.total_active_maintenance_costs || 0;
                const valorFinal = Number(product.supplier_value) - totalCustos;
                const hasCustos = custos.length > 0;

                return renderProductCard(
                  product,
                  <div className="flex flex-col text-xs text-gray-500 gap-2 mt-2">
                    <div className="flex justify-between items-center pb-2 border-b border-gray-50">
                      <span className="text-gray-500 font-medium">Devolvido em:</span>
                      <span className="text-red-600 font-medium">{product.returned_at ? new Date(product.returned_at).toLocaleDateString('pt-BR') : '-'}</span>
                    </div>

                    <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
                      <div className="bg-gray-50/50 p-2 rounded border border-gray-100 flex flex-col justify-center gap-1">
                        {product.sale_price > 0 ? (
                          <>
                            <p className="line-through decoration-red-400">Original: R$ {Number(product.base_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                            <p className="font-medium text-gray-900">Promoção: R$ {Number(product.sale_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                          </>
                        ) : (
                          <p className="font-medium text-gray-700">Preço: R$ {Number(product.base_price || product.price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        )}
                        {product.certificate_price > 0 && (
                          <p>Certificado: R$ {Number(product.certificate_price).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        )}
                        <p>Juros: R$ {Number(product.juros || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                        <p>Frete: R$ {Number(product.shipping_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="bg-[#849D70]/5 p-2 rounded">
                          <p className="font-medium text-[#849D70] mb-0.5">
                            À Vista: R$ {Number(product.total_avista || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                          <p className="font-semibold text-gray-900">
                            Parcelado: R$ {Number(product.total_parcelado || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </p>
                        </div>
                        <div className="border border-gray-100 rounded p-2 bg-white">
                          <div className="flex justify-between mb-0.5">
                            <span className="text-gray-500">Regra de Comissão:</span>
                            <span className="text-gray-700 font-medium">{product.fdc_comission_rule} ({product.fdc_comission_percent}%)</span>
                          </div>
                          <div className="flex justify-between items-center mb-0.5">
                            <span className="text-gray-500">Valor Retido FDC:</span>
                            <span className="flex items-center gap-1">
                              <span className="text-gray-900">- R$ {Number(product.fdc_comission_value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                              <button
                                onClick={() => handleAbrirVerRetido(product)}
                                title="Ver Detalhes"
                                className="flex items-center cursor-pointer text-[#D4C070] hover:text-[#BCA850] transition-colors"
                              >
                                <Eye className="h-4 w-4" />
                              </button>
                            </span>
                          </div>
                          {hasCustos && (
                            <div className="flex justify-between items-center">
                              <span className="text-gray-500">Custos Manutenção:</span>
                              <span className="flex items-center gap-1">
                                <span className="text-orange-600">- R$ {totalCustos.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                <button
                                  onClick={() => handleAbrirVerCustos(product, false)}
                                  title="Ver Detalhes"
                                  className="flex items-center cursor-pointer"
                                >
                                  <Eye className="h-3.5 w-3.5 text-[#D4C070] hover:text-[#BCA850] transition-colors" />
                                </button>
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="flex justify-between font-bold text-sm pt-2 mt-1 border-t border-gray-50">
                      <span className="text-gray-700 mt-1">Repasse Previsto:</span>
                      <span className="text-gray-400 text-base line-through">R$ {valorFinal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <main className="flex-1 p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="ghost"
          onClick={() => navigate('/clientes')}
          className="mb-4 text-[#68686A] hover:text-[#D4C070]"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar para Clientes
        </Button>
        <div className="flex items-center justify-between gap-4 flex-wrap">
          <div className="flex items-center gap-4 flex-wrap">
            <h1 className="text-2xl font-bold text-[#68686A]">
              Produtos - {customer ? `${customer.first_name} ${customer.last_name || ''}` : 'Carregando...'}
            </h1>
            {customer?.code && (
              <Badge variant="outline" className="bg-purple-100 text-purple-700 border-purple-200">
                Fornecedor ({customer.code})
              </Badge>
            )}
            {customer?.referred_by && (
              <Badge variant="outline" className="bg-blue-100 text-blue-700 border-blue-200">
                Indicado por: {customer.referred_by.name || `${customer.referred_by.first_name} ${customer.referred_by.last_name || ''}`}
              </Badge>
            )}
          </div>

          {/* Toggle de Modo: Visão Admin vs Visão do Cliente */}
          <div className="flex items-center bg-gray-200/70 p-1 rounded-lg border border-gray-300">
            <button
              onClick={() => setIsUserView(false)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md transition-all ${!isUserView
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              <Eye className="h-3.5 w-3.5 text-[#D4C070]" />
              Visão Admin
            </button>
            <button
              onClick={() => setIsUserView(true)}
              className={`flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md transition-all ${isUserView
                ? "bg-[#849D70] text-white shadow-sm"
                : "text-gray-600 hover:text-gray-900"
                }`}
            >
              <Users className="h-3.5 w-3.5" />
              Visão do Cliente
            </button>
          </div>
        </div>
      </div>

      {isUserView && (
        <div className="mb-4 bg-emerald-50 border border-emerald-200 rounded-lg p-3 flex items-center gap-2 text-xs text-emerald-800">
          <Users className="h-4 w-4 text-[#849D70] shrink-0" />
          <span>
            <strong>Modo Visão do Cliente Ativo:</strong> Você está visualizando os valores e o detalhamento exatamente como o cliente enxerga no extrato da loja (sem comissões internas da FDC ou botões administrativos).
          </span>
        </div>
      )}

      <Tabs value={activeTab} onValueChange={handleTabChange} className="space-y-6">
        <TabsList className="w-full h-auto flex flex-wrap justify-start bg-white border border-gray-200 rounded-lg p-1.5 gap-1.5">
          <TabsTrigger
            value="compras"
            className={`flex-1 min-w-[120px] sm:min-w-[140px] h-auto px-2.5 sm:px-3.5 py-2.5 rounded-md flex flex-wrap items-center justify-center ${activeTab === "compras" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <ShoppingCart className="h-4 w-4 mr-1.5 shrink-0" />
            <span className="whitespace-nowrap">Compras</span>
            <Badge variant="secondary" className="ml-1.5 bg-[#849D70] text-white shrink-0">{counts.compras}</Badge>
          </TabsTrigger>
          <TabsTrigger
            value="published"
            className={`flex-1 min-w-[120px] sm:min-w-[140px] h-auto px-2.5 sm:px-3.5 py-2.5 rounded-md flex flex-wrap items-center justify-center ${activeTab === "published" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <Package className="h-4 w-4 mr-1.5 shrink-0" />
            <span className="whitespace-nowrap">Publicados</span>
            <Badge variant="secondary" className="ml-1.5 bg-[#849D70] text-white shrink-0">{counts.published}</Badge>
          </TabsTrigger>
          <TabsTrigger
            value="returned"
            className={`flex-1 min-w-[120px] sm:min-w-[140px] h-auto px-2.5 sm:px-3.5 py-2.5 rounded-md flex flex-wrap items-center justify-center ${activeTab === "returned" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <Truck className="h-4 w-4 mr-1.5 shrink-0" />
            <span className="whitespace-nowrap">Em Trânsito</span>
            <Badge variant="secondary" className="ml-1.5 bg-[#849D70] text-white shrink-0">{counts.returned}</Badge>
          </TabsTrigger>
          <TabsTrigger
            value="saled"
            className={`flex-1 min-w-[120px] sm:min-w-[140px] h-auto px-2.5 sm:px-3.5 py-2.5 rounded-md flex flex-wrap items-center justify-center ${activeTab === "saled" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <DollarSign className="h-4 w-4 mr-1.5 shrink-0" />
            <span className="whitespace-nowrap">Vendidos</span>
            <Badge variant="secondary" className="ml-1.5 bg-[#849D70] text-white shrink-0">{counts.saled}</Badge>
          </TabsTrigger>
          <TabsTrigger
            value="paidout"
            className={`flex-1 min-w-[120px] sm:min-w-[140px] h-auto px-2.5 sm:px-3.5 py-2.5 rounded-md flex flex-wrap items-center justify-center ${activeTab === "paidout" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <Star className="h-4 w-4 mr-1.5 shrink-0" />
            <span className="whitespace-nowrap">Recebidos</span>
            <Badge variant="secondary" className="ml-1.5 bg-[#849D70] text-white shrink-0">{counts.paidout}</Badge>
          </TabsTrigger>
          <TabsTrigger
            value="desistence"
            className={`flex-1 min-w-[120px] sm:min-w-[140px] h-auto px-2.5 sm:px-3.5 py-2.5 rounded-md flex flex-wrap items-center justify-center ${activeTab === "desistence" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <XCircle className="h-4 w-4 mr-1.5 shrink-0" />
            <span className="whitespace-nowrap">Devolvidos</span>
            <Badge variant="secondary" className="ml-1.5 bg-[#849D70] text-white shrink-0">{counts.desistence}</Badge>
          </TabsTrigger>
          <TabsTrigger
            value="referrals"
            className={`flex-1 min-w-[130px] sm:min-w-[140px] h-auto px-3.5 py-2.5 rounded-md ${activeTab === "referrals" ? "!bg-[#D4C070] !text-white" : "text-[#68686A] hover:bg-[#EEF1F2]"}`}
          >
            <Users className="h-4 w-4 mr-2 shrink-0" />
            Indicações
          </TabsTrigger>
        </TabsList>

        <Card className="border border-gray-200 relative min-h-[300px]">
          {isLoading && (
            <div className="absolute inset-0 z-10 bg-white/50 flex items-center justify-center">
              <Loader2 className="h-8 w-8 animate-spin text-[#D4C070]" />
            </div>
          )}
          <CardContent className="p-0">
            {activeTab === "referrals" ? (
              <div className="p-6 space-y-6">
                {/* Formulário para Vincular Indicação */}
                <div className="bg-gray-50 p-4 rounded-xl border border-gray-100">
                  <h3 className="text-sm font-semibold text-gray-700 mb-3">Vincular Novo Indicado</h3>
                  <form onSubmit={handleAddReferral} className="flex gap-4 items-end flex-wrap">
                    <div className="flex-1 min-w-[250px] space-y-2">
                      <Label htmlFor="vincular_cliente" className="text-xs font-bold uppercase text-gray-500">Cliente Indicado</Label>
                      <AsyncSelect
                        value={selectedReferredId}
                        onChange={(idVal, _lbl, item) => {
                          setSelectedReferredId(idVal || "");
                          setSelectedReferredCustomer(item || null);
                        }}
                        fetcher={fetchCustomersForSelect}
                        placeholder="Buscar por código, nome ou e-mail..."
                        initialDisplay=""
                        getOptionLabel={(u) => {
                          const fullName = [u.first_name, u.last_name].filter(Boolean).join(" ") || u.name || "";
                          const codeVal = u.code || u.supplierCode || u.id;
                          return `[${codeVal}] ${fullName}${u.email ? ` (${u.email})` : ""}`;
                        }}
                        renderOption={(u) => (
                          <div className="flex items-center gap-3 py-1.5 w-full">
                            <div className="flex items-center justify-center min-w-[55px] bg-gray-800 text-white text-[10px] font-bold px-2 py-1 rounded border border-gray-700 uppercase tracking-tighter shadow-sm">
                              {u.code || u.supplierCode || u.id}
                            </div>
                            <div className="flex flex-col min-w-0 flex-1">
                              <div className="flex items-center gap-2 flex-wrap">
                                <span className="font-bold text-gray-900 truncate">
                                  {[u.first_name, u.last_name].filter(Boolean).join(" ") || u.name}
                                </span>
                                {u.active_indicator_name && (
                                  <span className="text-[10px] bg-amber-50 text-amber-700 border border-amber-200 px-1.5 py-0.5 rounded font-semibold">
                                    Indicado por {u.active_indicator_name}
                                  </span>
                                )}
                              </div>
                              {u.email && <span className="text-[10px] text-gray-500 truncate font-medium">{u.email}</span>}
                            </div>
                          </div>
                        )}
                      />
                    </div>
                    <Button
                      type="submit"
                      disabled={isSubmittingReferral || !selectedReferredId}
                      className="bg-[#D4C070] hover:bg-[#849D70] text-white h-10 font-bold text-xs px-6"
                    >
                      {isSubmittingReferral ? <Loader2 className="h-4 w-4 animate-spin" /> : "VINCULAR"}
                    </Button>
                  </form>
                </div>

                {/* Lista de Indicados Estilo PerfilIndicadosPage */}
                <div className="space-y-4">
                  <h3 className="text-sm font-semibold text-gray-700">Clientes Indicados por este Usuário</h3>
                  {loadingReferrals ? (
                    <div className="py-8 text-center text-gray-500 bg-white border border-gray-100 rounded-lg">
                      <Loader2 className="h-6 w-6 animate-spin text-[#D4C070] mx-auto mb-2" />
                      Carregando indicações...
                    </div>
                  ) : referrals.length === 0 ? (
                    <div className="text-center py-12 text-gray-500 bg-white border border-gray-100 rounded-lg">
                      <Users className="mx-auto h-10 w-10 text-gray-300 mb-2" />
                      <p className="text-sm font-medium text-gray-700">Este cliente ainda não realizou nenhuma indicação.</p>
                      <p className="text-xs text-gray-400 mt-0.5">Utilize o campo acima para vincular um novo indicado.</p>
                    </div>
                  ) : (
                    <div className="space-y-4">
                      {referrals.map((referred) => (
                        <div key={referred.id} className="bg-white border border-gray-200 rounded-xl overflow-hidden transition-all shadow-sm hover:shadow-md">
                          <div
                            onClick={() => handleToggleExpandReferral(referred)}
                            className="p-4 sm:p-5 flex flex-col xl:flex-row xl:items-center justify-between gap-4 cursor-pointer hover:bg-gray-50/70 select-none"
                          >
                            {/* Dados Básicos do Indicado */}
                            <div className="flex items-center gap-3">
                              <div className="h-10 w-10 rounded-full bg-[#D4C070]/10 flex items-center justify-center text-[#D4C070] font-bold text-sm shrink-0">
                                {referred.name?.split(' ').map((n: string) => n[0]).join('').substring(0, 2).toUpperCase() || 'IN'}
                              </div>
                              <div>
                                <div className="flex items-center gap-2 flex-wrap">
                                  <h4 className="font-bold text-gray-900 text-sm sm:text-base">{referred.name}</h4>
                                  {referred.is_active === false ? (
                                    <span className="text-[10px] bg-gray-100 text-gray-600 px-2 py-0.5 rounded border border-gray-200 font-semibold">
                                      Vínculo Finalizado
                                    </span>
                                  ) : (
                                    <span className="text-[10px] bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded border border-emerald-200 font-semibold">
                                      Vínculo Ativo
                                    </span>
                                  )}
                                </div>
                                <div className="flex items-center gap-2 flex-wrap text-xs text-gray-500 mt-0.5">
                                  <span>Cod: {referred.supplierCode || `#${referred.id}`}</span>
                                  <span className="text-gray-300">•</span>
                                  <span>{referred.email}</span>
                                  {referred.referred_commission_rate !== undefined && (
                                    <>
                                      <span className="text-gray-300">•</span>
                                      <span className="bg-[#849D70]/10 text-[#6B8357] px-2 py-0.5 rounded font-bold text-[11px]">
                                        Comissão: {referred.referred_commission_rate}%
                                      </span>
                                    </>
                                  )}
                                  {referred.started_at && (
                                    <>
                                      <span className="text-gray-300">•</span>
                                      <span className="bg-purple-50 text-purple-700 px-2 py-0.5 rounded font-medium text-[11px] border border-purple-100">
                                        Início: {new Date(referred.started_at).toLocaleDateString('pt-BR')} {new Date(referred.started_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                      </span>
                                    </>
                                  )}
                                  {referred.ended_at && (
                                    <>
                                      <span className="text-gray-300">•</span>
                                      <span className="bg-amber-50 text-amber-800 px-2 py-0.5 rounded font-medium text-[11px] border border-amber-200">
                                        Fim: {new Date(referred.ended_at).toLocaleDateString('pt-BR')} {new Date(referred.ended_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                                      </span>
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>

                            {/* Badges de Produtos e Ações */}
                            <div className="flex flex-col sm:flex-row items-stretch sm:items-center justify-between xl:justify-end gap-3 w-full xl:w-auto">
                              {/* Badges de Contagem de Produtos */}
                              {referred.is_active !== false ? (
                                <div className="flex flex-wrap items-center justify-center sm:justify-start xl:justify-center gap-1.5 sm:gap-2 text-xs font-bold uppercase w-full xl:w-auto text-center">
                                  <div className="flex-1 min-w-[95px] sm:min-w-[105px] bg-blue-50 px-2 sm:px-2.5 py-1.5 rounded-md text-blue-700 border border-blue-100 flex flex-nowrap items-center justify-center gap-1 whitespace-nowrap shrink-0">
                                    <span className="text-[10px] sm:text-[11px] font-semibold text-blue-600 whitespace-nowrap">Anunciados:</span>
                                    <span className="shrink-0">{referred.products_on_site || 0}</span>
                                  </div>
                                  <div className="flex-1 min-w-[95px] sm:min-w-[105px] bg-amber-50 px-2 sm:px-2.5 py-1.5 rounded-md text-amber-800 border border-amber-100 flex flex-nowrap items-center justify-center gap-1 whitespace-nowrap shrink-0">
                                    <span className="text-[10px] sm:text-[11px] font-semibold text-amber-600 whitespace-nowrap">A Receber:</span>
                                    <span className="shrink-0">{referred.products_sold || 0}</span>
                                  </div>
                                  <div className="flex-1 min-w-[95px] sm:min-w-[105px] bg-emerald-50 px-2 sm:px-2.5 py-1.5 rounded-md text-emerald-800 border border-emerald-100 flex flex-nowrap items-center justify-center gap-1 whitespace-nowrap shrink-0">
                                    <span className="text-[10px] sm:text-[11px] font-semibold text-emerald-600 whitespace-nowrap">Recebidos:</span>
                                    <span className="shrink-0">{referred.products_paid || 0}</span>
                                  </div>
                                </div>
                              ) : (
                                <div className="flex flex-wrap items-center justify-center sm:justify-start xl:justify-center gap-1.5 sm:gap-2 text-xs font-bold uppercase w-full xl:w-auto text-center">
                                  <div className="flex-1 min-w-[95px] sm:min-w-[105px] bg-amber-50 px-2 sm:px-2.5 py-1.5 rounded-md text-amber-800 border border-amber-100 flex flex-nowrap items-center justify-center gap-1 whitespace-nowrap shrink-0">
                                    <span className="text-[10px] sm:text-[11px] font-semibold text-amber-600 whitespace-nowrap">A Receber:</span>
                                    <span className="shrink-0">{referred.products_sold || 0}</span>
                                  </div>
                                  <div className="flex-1 min-w-[95px] sm:min-w-[105px] bg-emerald-50 px-2 sm:px-2.5 py-1.5 rounded-md text-emerald-800 border border-emerald-100 flex flex-nowrap items-center justify-center gap-1 whitespace-nowrap shrink-0">
                                    <span className="text-[10px] sm:text-[11px] font-semibold text-emerald-600 whitespace-nowrap">Recebidos:</span>
                                    <span className="shrink-0">{referred.products_paid || 0}</span>
                                  </div>
                                </div>
                              )}

                              {/* Ações (Editar, Desvincular, Deletar, Expandir) */}
                              <div className="flex flex-wrap items-center gap-1 shrink-0" onClick={(e) => e.stopPropagation()}>
                                {!isUserView && (
                                  <>
                                    {canEditReferralDates && (
                                      <Button
                                        size="sm"
                                        variant="outline"
                                        onClick={() => handleOpenEditDatesModal(referred)}
                                        className="text-purple-700 border-purple-200 hover:bg-purple-50 h-8 px-2 text-xs font-semibold"
                                        title="Editar Datas de Início/Fim (Exclusivo Ronald)"
                                      >
                                        <Calendar className="h-3.5 w-3.5 mr-1 text-purple-600" />
                                        Editar Datas
                                      </Button>
                                    )}
                                    {referred.is_active !== false && (
                                      <>
                                        <Button
                                          size="sm"
                                          variant="outline"
                                          onClick={() => handleOpenEditCommissionModal(referred)}
                                          className="text-gray-700 border-gray-300 hover:bg-gray-100 h-8 px-2 text-xs font-semibold"
                                          title="Alterar Comissão"
                                        >
                                          <Edit3 className="h-3.5 w-3.5 mr-1 text-[#D4C070]" />
                                          Alterar
                                        </Button>
                                        <Button
                                          size="sm"
                                          variant="ghost"
                                          onClick={() => handleOpenRemoveReferralModal(referred)}
                                          className="text-amber-700 hover:text-amber-800 hover:bg-amber-50 text-xs font-semibold h-8 px-2"
                                          title="Desvincular Indicado"
                                        >
                                          Desvincular
                                        </Button>
                                      </>
                                    )}
                                    <Button
                                      size="sm"
                                      variant="ghost"
                                      onClick={() => handleOpenDeleteReferralModal(referred)}
                                      className="text-red-600 hover:text-red-800 hover:bg-red-50 text-xs font-semibold h-8 px-2"
                                      title="Deletar Relação de Indicação"
                                    >
                                      <Trash2 className="h-3.5 w-3.5 mr-1" />
                                      Deletar
                                    </Button>
                                  </>
                                )}
                                <Button
                                  size="sm"
                                  variant="ghost"
                                  onClick={() => handleToggleExpandReferral(referred)}
                                  className="text-gray-500 hover:text-gray-900 p-1 h-8 w-8"
                                >
                                  {expandedReferredId === referred.id ? (
                                    <ChevronUp className="h-5 w-5 text-gray-600" />
                                  ) : (
                                    <ChevronDown className="h-5 w-5 text-gray-400" />
                                  )}
                                </Button>
                              </div>
                            </div>
                          </div>

                          {/* Detalhamento Inline de Produtos do Indicado Expandido */}
                          {expandedReferredId === referred.id && (
                            <div className="border-t border-gray-200 bg-gray-50/50 p-4 sm:p-5 space-y-4">
                              {/* Sub-abas de produtos */}
                              <div className="w-full h-auto flex flex-wrap justify-start bg-white border border-gray-200 rounded-lg p-1.5 gap-1.5 mb-4">
                                {referred.is_active !== false && (
                                  <button
                                    onClick={() => {
                                      setInlineProductsTab('published');
                                      fetchInlineReferredProducts(referred.id, 'published');
                                    }}
                                    className={`flex-1 min-w-[120px] sm:min-w-[130px] h-auto px-3.5 py-2.5 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${inlineProductsTab === 'published'
                                      ? "!bg-[#D4C070] !text-white shadow-sm"
                                      : "text-[#68686A] hover:bg-[#EEF1F2]"
                                      }`}
                                  >
                                    <Package className="h-4 w-4 mr-1.5 shrink-0" />
                                    <span>Anunciados</span>
                                    <span className="ml-2 px-2 py-0.5 text-xs font-semibold rounded-full shrink-0 bg-[#849D70] text-white">
                                      {referred.products_on_site || 0}
                                    </span>
                                  </button>
                                )}
                                <button
                                  onClick={() => {
                                    setInlineProductsTab('saled');
                                    fetchInlineReferredProducts(referred.id, 'saled');
                                  }}
                                  className={`flex-1 min-w-[120px] sm:min-w-[130px] h-auto px-3.5 py-2.5 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${inlineProductsTab === 'saled'
                                    ? "!bg-[#D4C070] !text-white shadow-sm"
                                    : "text-[#68686A] hover:bg-[#EEF1F2]"
                                    }`}
                                >
                                  <DollarSign className="h-4 w-4 mr-1.5 shrink-0" />
                                  <span>A Receber</span>
                                  <span className="ml-2 px-2 py-0.5 text-xs font-semibold rounded-full shrink-0 bg-[#849D70] text-white">
                                    {referred.products_sold || 0}
                                  </span>
                                </button>
                                <button
                                  onClick={() => {
                                    setInlineProductsTab('paied');
                                    fetchInlineReferredProducts(referred.id, 'paied');
                                  }}
                                  className={`flex-1 min-w-[120px] sm:min-w-[130px] h-auto px-3.5 py-2.5 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${inlineProductsTab === 'paied'
                                    ? "!bg-[#D4C070] !text-white shadow-sm"
                                    : "text-[#68686A] hover:bg-[#EEF1F2]"
                                    }`}
                                >
                                  <Star className="h-4 w-4 mr-1.5 shrink-0" />
                                  <span>Recebidos</span>
                                  <span className="ml-2 px-2 py-0.5 text-xs font-semibold rounded-full shrink-0 bg-[#849D70] text-white">
                                    {referred.products_paid || 0}
                                  </span>
                                </button>
                              </div>

                              {/* Conteúdo de Produtos */}
                              {loadingInlineProducts ? (
                                <div className="flex justify-center py-8">
                                  <Loader2 className="animate-spin h-6 w-6 text-[#D4C070]" />
                                </div>
                              ) : inlineReferredProducts.length === 0 ? (
                                <p className="text-xs text-gray-500 italic text-center py-6">Nenhum produto nesta categoria para este indicado.</p>
                              ) : (
                                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                  {inlineReferredProducts.map((product) => (
                                    <div key={product.id} className="relative flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow p-4">
                                      <div className="flex items-center gap-3">
                                        {product.images?.[0] ? (
                                          <img
                                            src={getImageUrl(typeof product.images[0] === 'string' ? product.images[0] : (product.images[0]?.image || product.images[0]?.url || ''))}
                                            alt={product.name}
                                            className="w-14 h-14 object-cover rounded bg-white border border-gray-200 shrink-0"
                                          />
                                        ) : (
                                          <div className="w-14 h-14 bg-gray-50 flex items-center justify-center rounded border border-gray-200 text-gray-400 shrink-0">
                                            <Package className="w-6 h-6 opacity-20" />
                                          </div>
                                        )}
                                        <div className="flex-1 min-w-0">
                                          <h4 className="font-bold text-gray-900 break-words line-clamp-2 text-sm" title={product.name}>
                                            {product.name}
                                          </h4>
                                          <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                                            <p className="text-xs text-gray-500 font-medium">Ref: {product.sku || '-'}</p>
                                            {product.product_referral_commission_rate !== null && product.product_referral_commission_rate !== undefined && (
                                              <span className="text-[10px] bg-purple-50 text-purple-700 border border-purple-200 px-1.5 py-0.5 rounded font-semibold">
                                                Taxa Especial: {product.product_referral_commission_rate}%
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                      </div>

                                      <div className="flex-1 flex flex-col mt-3 pt-3 border-t border-gray-100">
                                        <div className="bg-[#849D70]/5 p-3 rounded-lg border border-[#849D70]/10 space-y-1.5">
                                          <div className="flex justify-between items-center pt-1.5 font-bold text-xs sm:text-sm">
                                            <span className="text-[#849D70]">
                                              {inlineProductsTab === 'paied'
                                                ? `Comissão Recebida:`
                                                : inlineProductsTab === 'saled'
                                                  ? `Comissão A Receber:`
                                                  : `Estimativa de Comissão:`
                                              }
                                            </span>
                                            <span className="text-[#849D70] font-bold text-sm sm:text-base">
                                              {product.on_request || Number(product.price || 0) <= 0 ? 'Sob Consulta' : formatCurrency(product.estimated_commission)}
                                            </span>
                                          </div>
                                          {product.paidout_at && (
                                            <div className="flex items-center justify-end text-[11px] mt-2 pt-2 border-t border-gray-100">
                                              <span className="text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded font-semibold">
                                                Repasse Concluído em: {new Date(product.paidout_at).toLocaleDateString('pt-BR')}
                                              </span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <>
                {isUserView && activeTab === "returned" && (
                  <div className="bg-amber-50 border border-amber-200 text-amber-900 px-4 py-3 rounded-lg text-sm font-medium flex items-center gap-2 mb-4 mx-4 mt-4">
                    <Info className="h-4 w-4 shrink-0 text-amber-600" />
                    <span>Produtos devolvidos pelo comprador. Em breve voltarão para publicados.</span>
                  </div>
                )}
                {isUserView && activeTab === "desistence" && (
                  <div className="bg-amber-50 border border-amber-200 text-amber-900 px-4 py-3 rounded-lg text-sm font-medium flex items-center gap-2 mb-4 mx-4 mt-4">
                    <Info className="h-4 w-4 shrink-0 text-amber-600" />
                    <span>Produtos devolvidos para você. Caso deseje vender novamente, podemos reativar o anúncio.</span>
                  </div>
                )}

                {(dataList.length === 0 && !isLoading) ? (
                  <div className="p-8 text-center text-gray-500">Nenhum registro encontrado nesta categoria.</div>
                ) : (
                  <>
                    {activeTab === "compras" && renderComprasTable(dataList)}
                    {activeTab === "published" && renderPublicadosTable(dataList)}
                    {activeTab === "saled" && renderVendidosTable(dataList)}
                    {activeTab === "paidout" && renderRecebidosTable(dataList)}
                    {activeTab === "returned" && renderDevolvidosTable(dataList)}
                    {activeTab === "desistence" && renderDesistenciaTable(dataList)}
                  </>
                )}
              </>
            )}
          </CardContent>
        </Card>
      </Tabs>

      {/* Paginação */}
      {activeTab !== "referrals" && pagination.last_page > 1 && (
        <div className="flex items-center justify-center mt-6">
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              disabled={pagination.current_page === 1}
              onClick={() => handlePageChange(pagination.current_page - 1)}
            >
              {'<'}
            </Button>
            {getPageNumbers(pagination.current_page, pagination.last_page).map((p, i) => {
              if (p === '...') {
                return (
                  <span key={`ellipsis-${i}`} className="h-8 px-1.5 inline-flex items-center justify-center text-xs text-gray-400 font-medium select-none">
                    ...
                  </span>
                );
              }
              return (
                <Button
                  key={p}
                  variant={pagination.current_page === p ? "default" : "outline"}
                  size="sm"
                  className={pagination.current_page === p ? "bg-[#D4C070] hover:bg-[#D4C070] text-white" : "text-[#68686A]"}
                  onClick={() => handlePageChange(p as number)}
                >
                  {p}
                </Button>
              );
            })}
            <Button
              variant="outline"
              size="sm"
              disabled={pagination.current_page === pagination.last_page}
              onClick={() => handlePageChange(pagination.current_page + 1)}
            >
              {'>'}
            </Button>
          </div>
        </div>
      )}

      {/* Modais */}
      <AdicionarManutencaoDialog
        open={manutencaoDialogOpen}
        onOpenChange={setManutencaoDialogOpen}
        produtoNome={produtoSelecionado?.name}
        produtoId={produtoSelecionado?.id}
        clienteId={Number(id)}
        custosExistentes={produtoSelecionado?.maintenance_costs || []}
        onSuccess={fetchData}
      />

      <Dialog open={paymentDialogOpen} onOpenChange={setPaymentDialogOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Informar Pagamento</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 py-4">
            <div>
              <Label className="mb-1.5 block text-sm font-medium">Data do Pagamento</Label>
              <Input
                type="date"
                value={paymentDate}
                onChange={(e) => setPaymentDate(e.target.value)}
              />
            </div>

            {/* Custos de Manutenção & Resumo */}
            {(() => {
              const repasseBruto = Number(produtoSelecionado?.supplier_value || 0);

              const selectedCostsList = pendingCosts.filter(c => selectedCostIds.includes(c.id));
              const totalCustosSelecionados = selectedCostsList.reduce((acc, c) => acc + Number(c.cost || 0), 0);

              const selectedOwnCostsList = selectedCostsList.filter(c => c.product_id === produtoSelecionado?.id);
              const selectedOtherCostsList = selectedCostsList.filter(c => c.product_id !== produtoSelecionado?.id);

              const selectedOwnCostsTotal = selectedOwnCostsList.reduce((acc, c) => acc + Number(c.cost || 0), 0);
              const selectedOtherCostsTotal = selectedOtherCostsList.reduce((acc, c) => acc + Number(c.cost || 0), 0);

              const valorLiquido = repasseBruto - totalCustosSelecionados;
              const isExceeded = totalCustosSelecionados > (repasseBruto + 0.01);

              return (
                <>
                  {pendingCosts.length > 0 && (
                    <div className="border-t border-gray-100 pt-3">
                      <div className="flex justify-between items-center mb-2">
                        <Label className="block text-sm font-semibold text-gray-700">
                          Abater custos de manutenção:
                        </Label>
                        <span className="text-xs text-gray-500 font-mono">
                          Repasse Bruto: R$ {repasseBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                      </div>

                      <div className="max-h-48 overflow-y-auto space-y-2 pr-1">
                        {pendingCosts.map((cost) => {
                          const isChecked = selectedCostIds.includes(cost.id);
                          const isOwnProduct = cost.product_id === produtoSelecionado?.id;
                          const currentTotal = totalCustosSelecionados;
                          const wouldExceed = !isChecked && (currentTotal + Number(cost.cost) > (repasseBruto + 0.01));

                          return (
                            <div
                              key={cost.id}
                              className={`flex items-start gap-2.5 p-2 rounded border transition-colors ${isChecked
                                ? 'bg-orange-50/60 border-orange-200'
                                : wouldExceed
                                  ? 'bg-gray-50/50 border-gray-200 opacity-60'
                                  : 'bg-gray-50 border-gray-100 hover:bg-gray-100/70'
                                }`}
                            >
                              <input
                                type="checkbox"
                                id={`cost-${cost.id}`}
                                checked={isChecked}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    setSelectedCostIds([...selectedCostIds, cost.id]);
                                  } else {
                                    setSelectedCostIds(selectedCostIds.filter(id => id !== cost.id));
                                  }
                                }}
                                className="mt-1 h-4 w-4 rounded border-gray-300 text-[#D4C070] focus:ring-[#D4C070]"
                              />
                              <label htmlFor={`cost-${cost.id}`} className="text-xs text-gray-600 flex-1 cursor-pointer">
                                <div className="flex justify-between items-start gap-2">
                                  <div className="flex items-center gap-1.5 min-w-0">
                                    <span className="font-semibold text-gray-900 truncate" title={cost.product_name || cost.product_sku}>
                                      {cost.product_name || 'Produto'}
                                    </span>
                                    {isOwnProduct ? (
                                      <Badge variant="outline" className="text-[10px] bg-blue-50 text-blue-700 border-blue-200 shrink-0">
                                        Deste produto
                                      </Badge>
                                    ) : (
                                      <Badge variant="outline" className="text-[10px] bg-amber-50 text-amber-700 border-amber-200 shrink-0">
                                        Outro produto
                                      </Badge>
                                    )}
                                  </div>
                                  {wouldExceed && (
                                    <span className="text-[10px] text-red-600 font-medium shrink-0">Excede repasse</span>
                                  )}
                                </div>
                                <p className="text-gray-500 mt-0.5">{cost.description}</p>
                                <p className="font-bold text-orange-600 mt-0.5">R$ {Number(cost.cost).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
                              </label>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Resumo de Repasse */}
                  {produtoSelecionado && (
                    <div className="bg-[#849D70]/5 p-3 rounded-lg border border-[#849D70]/10 text-xs space-y-1.5 mt-4">
                      <div className="flex justify-between text-gray-600">
                        <span>Repasse Bruto:</span>
                        <span>R$ {repasseBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                      </div>
                      {selectedOwnCostsTotal > 0 && (
                        <div className="flex justify-between text-orange-700">
                          <span>Custos Deste Produto ({selectedOwnCostsList.length}):</span>
                          <span>- R$ {selectedOwnCostsTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </div>
                      )}
                      {selectedOtherCostsTotal > 0 && (
                        <div className="flex justify-between text-amber-700">
                          <span>Custos de Outros Produtos ({selectedOtherCostsList.length}):</span>
                          <span>- R$ {selectedOtherCostsTotal.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                        </div>
                      )}
                      <div className="flex justify-between font-bold text-sm border-t border-[#849D70]/20 pt-1.5 mt-1.5">
                        <span>Valor Líquido a Pagar:</span>
                        <span className={isExceeded ? "text-red-600 font-bold" : "text-[#849D70]"}>
                          R$ {valorLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                      </div>
                      {isExceeded && (
                        <div className="bg-red-50 text-red-700 p-2 rounded text-[11px] font-medium mt-1 border border-red-200">
                          ⚠️ O total de custos selecionados excede o repasse disponível em R$ {Math.abs(valorLiquido).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}. Desmarque alguns custos para salvar.
                        </div>
                      )}
                    </div>
                  )}

                  <DialogFooter className={`flex w-full sm:w-auto mt-4 ${activeTab === 'paidout' ? 'justify-between sm:justify-between' : 'justify-end sm:justify-end'}`}>
                    {activeTab === 'paidout' && (
                      <Button
                        variant="outline"
                        className="text-red-600 border-red-200 hover:bg-red-50 hover:text-red-700"
                        onClick={() => handleConfirmarPagamento(true)}
                        disabled={isSubmittingPayment}
                      >
                        Retornar para Vendidos
                      </Button>
                    )}
                    <div className="flex gap-2">
                      <Button variant="outline" onClick={() => setPaymentDialogOpen(false)} disabled={isSubmittingPayment}>Cancelar</Button>
                      <Button onClick={() => handleConfirmarPagamento(false)} disabled={!paymentDate || isSubmittingPayment || isExceeded}>
                        {isSubmittingPayment ? 'Salvando...' : 'Salvar'}
                      </Button>
                    </div>
                  </DialogFooter>
                </>
              );
            })()}
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal Ver Custos */}
      <Dialog open={custosDialogOpen} onOpenChange={setCustosDialogOpen}>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogTitle>{visualizingOutrosCustos ? "Custos de Manutenção Quitados" : "Custos de Manutenção"}</DialogTitle>
          </DialogHeader>
          <div className="py-4 flex flex-col gap-3 max-h-[60vh] overflow-y-auto">
            {(() => {
              const custosExibidos = visualizingOutrosCustos
                ? custosProduto?.paid_maintenance_costs || []
                : custosProduto?.maintenance_costs || [];
              const totalCost = custosExibidos.reduce((acc: number, c: any) => acc + Number(c.cost), 0);

              return (
                <>
                  {custosExibidos.length > 0 ? (
                    custosExibidos.map((custo: any, index: number) => (
                      <div key={index} className="flex flex-col border-b border-gray-100 pb-2">
                        <div className="flex justify-between items-center">
                          <span className="text-gray-700">{custo.description || 'Custo sem descrição'}</span>
                          <span className="font-semibold text-orange-600">
                            R$ {Number(custo.cost).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </span>
                        </div>
                        {custo.paid_by_product_name && (
                          <span className="text-[10px] text-gray-500 font-medium italic mt-0.5">
                            Quitado pelo produto: {custo.paid_by_product_name}
                          </span>
                        )}
                        {visualizingOutrosCustos && custo.product_name && (
                          <span className="text-[10px] text-gray-500 font-medium italic mt-0.5">
                            Do produto: {custo.product_name} {custo.product_sku ? `(${custo.product_sku})` : ''}
                          </span>
                        )}
                      </div>
                    ))
                  ) : (
                    <p className="text-gray-500 text-center">Nenhum custo registrado.</p>
                  )}
                  <div className="flex justify-between items-center pt-2 font-bold text-gray-900 border-t border-gray-200 mt-2">
                    <span>Total:</span>
                    <span>
                      R$ {totalCost.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                  </div>
                </>
              );
            })()}
          </div>
          <DialogFooter>
            <Button onClick={() => setCustosDialogOpen(false)}>Fechar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Detalhes Retenção */}
      <Dialog open={retidoDialogOpen} onOpenChange={setRetidoDialogOpen}>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogTitle>Detalhes: Valor Retido FDC</DialogTitle>
          </DialogHeader>
          {retidoProduto && (
            <div className="py-4 flex flex-col gap-3 text-sm">
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-600">Comissão ({retidoProduto.fdc_comission_rule}):</span>
                <span className="font-medium text-gray-900">
                  {retidoProduto.fdc_comission_percent > 0
                    ? `R$ ${Number(retidoProduto.fdc_comission_value - (retidoProduto.certificate_price || 0)).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} (${retidoProduto.fdc_comission_percent}%)`
                    : 'R$ 0,00 (0%)'}
                </span>
              </div>
              <div className="flex justify-between border-b border-gray-100 pb-2">
                <span className="text-gray-600">Certificado FDC:</span>
                <span className="font-medium text-gray-900">R$ {Number(retidoProduto.certificate_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <div className="flex justify-between pt-1 font-bold text-base text-gray-900">
                <span>Total Retido:</span>
                <span>R$ {Number(retidoProduto.fdc_comission_value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
              </div>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed">
                O valor retido pela FDC é a diferença entre o total que o cliente final pagou (à vista) e o valor a ser repassado para a vendedora. Corresponde à comissão acordada mais taxas fixas (como emissão de certificado).
              </p>
            </div>
          )}
          <DialogFooter>
            <Button onClick={() => setRetidoDialogOpen(false)}>Fechar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Rastreio */}
      <Dialog open={shippingDialogOpen} onOpenChange={setShippingDialogOpen}>
        <DialogContent className="sm:max-w-[400px]">
          <DialogHeader>
            <DialogTitle>Informar Rastreio</DialogTitle>
          </DialogHeader>
          <div className="py-4">
            <Label className="mb-2 block">Código de Rastreio</Label>
            <Input
              type="text"
              placeholder="Ex: AB123456789BR"
              value={shippingCode}
              onChange={(e) => setShippingCode(e.target.value)}
            />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShippingDialogOpen(false)} disabled={isSubmittingShipping}>Cancelar</Button>
            <Button onClick={handleConfirmarShipping} disabled={isSubmittingShipping}>
              {isSubmittingShipping ? 'Salvando...' : 'Salvar'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Alterar Comissão */}
      {selectedReferredForEdit && (
        <Dialog open={editCommissionDialogOpen} onOpenChange={setEditCommissionDialogOpen}>
          <DialogContent className="sm:max-w-[420px] bg-white p-6 rounded-xl shadow-lg border border-gray-100">
            <DialogHeader className="mb-2">
              <DialogTitle className="text-lg font-bold text-gray-900 flex items-center gap-2">
                <Edit3 className="h-5 w-5 text-[#D4C070]" />
                Alterar Comissão de Indicação
              </DialogTitle>
            </DialogHeader>

            <div className="py-3 space-y-4">
              <p className="text-xs text-gray-600">
                Ajuste o percentual de comissão individual que o cliente <strong className="text-gray-900">{selectedReferredForEdit.name}</strong> gera para este padrinho.
              </p>

              <div className="space-y-2">
                <Label htmlFor="comm_rate" className="text-xs font-bold uppercase text-gray-500">Taxa de Comissão (%)</Label>
                <div className="relative">
                  <Input
                    id="comm_rate"
                    type="text"
                    value={editingCommissionValue}
                    onChange={(e) => setEditingCommissionValue(limitPercentage(e.target.value))}
                    placeholder="0"
                    className="bg-gray-50 border-gray-200 focus:ring-[#D4C070] pr-8"
                  />
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 font-bold text-sm">%</span>
                </div>
              </div>
            </div>

            <DialogFooter className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-100">
              <Button
                variant="outline"
                onClick={() => setEditCommissionDialogOpen(false)}
                className="text-gray-600 border-gray-300"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmSaveCommission}
                disabled={isSavingCommission}
                className="bg-[#D4C070] hover:bg-[#849D70] text-white font-bold"
              >
                {isSavingCommission ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar Alteração"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {/* Modal Editar Datas da Indicação (Exclusivo ronald@ronald.com) */}
      {selectedReferredForEditDates && (
        <Dialog open={editDatesDialogOpen} onOpenChange={setEditDatesDialogOpen}>
          <DialogContent className="sm:max-w-[440px] bg-white p-6 rounded-xl shadow-lg border border-gray-100">
            <DialogHeader className="mb-2">
              <DialogTitle className="text-lg font-bold text-purple-900 flex items-center gap-2">
                <Calendar className="h-5 w-5 text-purple-600" />
                Editar Datas do Vínculo de Indicação
              </DialogTitle>
            </DialogHeader>

            <div className="py-3 space-y-4">
              <p className="text-xs text-gray-600 leading-relaxed">
                Ajuste os períodos em que a indicação do cliente <strong className="text-gray-900">{selectedReferredForEditDates.name}</strong> esteve ativa no sistema.
              </p>

              <div className="space-y-3 bg-purple-50/50 p-3.5 rounded-lg border border-purple-100">
                <div className="space-y-1">
                  <Label htmlFor="started_at" className="text-xs font-bold uppercase text-purple-900">Data de Início (started_at)</Label>
                  <Input
                    id="started_at"
                    type="datetime-local"
                    value={editingStartedAt}
                    onChange={(e) => setEditingStartedAt(e.target.value)}
                    className="bg-white border-purple-200 focus:ring-purple-500 text-xs"
                  />
                  <p className="text-[11px] text-purple-700">Produtos vendidos após esta data gerarão comissão para o padrinho.</p>
                </div>

                <div className="space-y-1 pt-2 border-t border-purple-100">
                  <div className="flex justify-between items-center">
                    <Label htmlFor="ended_at" className="text-xs font-bold uppercase text-purple-900">Data de Término (ended_at)</Label>
                    {editingEndedAt && (
                      <button
                        type="button"
                        onClick={() => setEditingEndedAt("")}
                        className="text-[10px] text-amber-700 hover:underline font-semibold"
                      >
                        Limpar (Tornar Ativo)
                      </button>
                    )}
                  </div>
                  <Input
                    id="ended_at"
                    type="datetime-local"
                    value={editingEndedAt}
                    onChange={(e) => setEditingEndedAt(e.target.value)}
                    className="bg-white border-purple-200 focus:ring-purple-500 text-xs"
                  />
                  <p className="text-[11px] text-purple-700">Deixe em branco se o vínculo de indicação continuar ativo.</p>
                </div>
              </div>
            </div>

            <DialogFooter className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-100">
              <Button
                variant="outline"
                onClick={() => setEditDatesDialogOpen(false)}
                className="text-gray-600 border-gray-300"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmSaveDates}
                disabled={isSavingDates}
                className="bg-purple-700 hover:bg-purple-800 text-white font-bold"
              >
                {isSavingDates ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar Datas"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {/* Modal Confirmar Desvinculação */}
      {selectedReferredForRemove && (
        <Dialog open={removeReferralDialogOpen} onOpenChange={setRemoveReferralDialogOpen}>
          <DialogContent className="sm:max-w-[420px] bg-white p-6 rounded-xl shadow-lg border border-gray-100">
            <DialogHeader className="mb-2">
              <DialogTitle className="text-lg font-bold text-amber-800 flex items-center gap-2">
                <XCircle className="h-5 w-5 text-amber-600" />
                Desvincular Indicado
              </DialogTitle>
            </DialogHeader>

            <div className="py-3 space-y-3">
              <p className="text-sm text-gray-700">
                Tem certeza que deseja desvincular o cliente <strong className="text-gray-900">{selectedReferredForRemove.name}</strong> deste padrinho?
              </p>
              <p className="text-xs text-gray-500 bg-amber-50 p-3 rounded border border-amber-100">
                Esta ação encerrará o vínculo ativo (`ended_at`). O histórico de comissões passadas será preservado, mas novos produtos não gerarão comissões.
              </p>
            </div>

            <DialogFooter className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-100">
              <Button
                variant="outline"
                onClick={() => setRemoveReferralDialogOpen(false)}
                className="text-gray-600 border-gray-300"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmRemoveReferral}
                disabled={isRemovingReferral}
                className="bg-amber-600 hover:bg-amber-700 text-white font-bold"
              >
                {isRemovingReferral ? <Loader2 className="h-4 w-4 animate-spin" /> : "Confirmar Desvinculação"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {/* Modal Deletar Relação de Indicação */}
      {selectedReferredForDelete && (
        <Dialog open={deleteReferralDialogOpen} onOpenChange={setDeleteReferralDialogOpen}>
          <DialogContent className="sm:max-w-[420px] bg-white p-6 rounded-xl shadow-lg border border-gray-100">
            <DialogHeader className="mb-2">
              <DialogTitle className="text-lg font-bold text-red-600 flex items-center gap-2">
                <Trash2 className="h-5 w-5 text-red-600" />
                Deletar Indicação
              </DialogTitle>
            </DialogHeader>

            <div className="py-3 space-y-3">
              <p className="text-sm text-gray-700">
                Tem certeza que deseja <strong className="text-red-600">deletar permanentemente</strong> a relação de indicação do cliente <strong className="text-gray-900">{selectedReferredForDelete.name}</strong>?
              </p>
            </div>

            <DialogFooter className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-100">
              <Button
                variant="outline"
                onClick={() => setDeleteReferralDialogOpen(false)}
                className="text-gray-600 border-gray-300"
              >
                Cancelar
              </Button>
              <Button
                onClick={handleConfirmDeleteReferral}
                disabled={isDeletingReferral}
                className="bg-red-600 hover:bg-red-700 text-white font-bold"
              >
                {isDeletingReferral ? <Loader2 className="h-4 w-4 animate-spin" /> : "Deletar Indicação"}
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}

      {/* Modal Confirmar Troca de Indicação */}
      <Dialog open={confirmTransferDialogOpen} onOpenChange={setConfirmTransferDialogOpen}>
        <DialogContent className="sm:max-w-[460px] bg-white p-6 rounded-xl shadow-lg border border-gray-100">
          <DialogHeader className="mb-2">
            <DialogTitle className="text-lg font-bold text-amber-800 flex items-center gap-2">
              <Users className="h-5 w-5 text-amber-600" />
              Atenção: Troca de Indicação
            </DialogTitle>
          </DialogHeader>

          <div className="py-3 space-y-3">
            <p className="text-sm text-gray-700 leading-relaxed">
              O cliente <strong className="text-gray-900 font-semibold">{selectedReferredCustomer?.name || [selectedReferredCustomer?.first_name, selectedReferredCustomer?.last_name].filter(Boolean).join(" ")}</strong> já possui uma indicação ativa associada a <strong className="text-amber-900 font-bold">{selectedReferredCustomer?.active_indicator_name}</strong>.
            </p>
            <div className="bg-amber-50 p-3 rounded-lg border border-amber-200 text-xs text-amber-900 leading-relaxed space-y-1">
              <p className="font-semibold">O que acontecerá ao confirmar:</p>
              <ul className="list-disc list-inside space-y-0.5">
                <li>O vínculo anterior com <strong>{selectedReferredCustomer?.active_indicator_name}</strong> será encerrado.</li>
                <li>Este cliente passará a ser indicado por <strong>{customer ? ([customer.first_name, customer.last_name].filter(Boolean).join(" ") || customer.name) : 'este padrinho'}</strong>.</li>
              </ul>
            </div>
            <p className="text-xs text-gray-500">Deseja realmente transferir esta indicação?</p>
          </div>

          <DialogFooter className="flex justify-end gap-2 mt-4 pt-3 border-t border-gray-100">
            <Button
              variant="outline"
              onClick={() => setConfirmTransferDialogOpen(false)}
              disabled={isSubmittingReferral}
              className="text-gray-600 border-gray-300"
            >
              Cancelar
            </Button>
            <Button
              onClick={executeAddReferral}
              disabled={isSubmittingReferral}
              className="bg-amber-600 hover:bg-amber-700 text-white font-bold gap-2"
            >
              {isSubmittingReferral ? <Loader2 className="h-4 w-4 animate-spin" /> : "Confirmar Troca de Indicação"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      {/* Modal Ver Perfil do Indicado */}
      {selectedReferredForProfile && (
        <Dialog open={referredProfileDialogOpen} onOpenChange={setReferredProfileDialogOpen}>
          <DialogContent className="sm:max-w-[850px] bg-white p-6 rounded-xl shadow-xl border border-gray-100 max-h-[85vh] flex flex-col">
            <DialogHeader className="mb-4 pb-3 border-b border-gray-100 flex flex-row items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-[#D4C070]/10 flex items-center justify-center text-[#D4C070] font-bold text-sm">
                  {selectedReferredForProfile.name?.split(' ').map((n: string) => n[0]).join('').substring(0, 2).toUpperCase()}
                </div>
                <div>
                  <DialogTitle className="text-lg font-bold text-gray-900">
                    {selectedReferredForProfile.name}
                  </DialogTitle>
                  <p className="text-xs text-gray-500">
                    Cód: {selectedReferredForProfile.supplierCode || `#${selectedReferredForProfile.id}`} | {selectedReferredForProfile.email}
                  </p>
                </div>
              </div>
            </DialogHeader>

            <div className="flex-1 overflow-y-auto space-y-4 pr-1">
              {/* Resumo de Status / Vendas */}
              <div className="flex flex-wrap gap-4 p-3 bg-gray-50 rounded-lg border border-gray-100 text-xs font-semibold justify-between items-center">
                <div className="flex gap-3">
                  <span className="bg-blue-50 text-blue-700 px-2.5 py-1 rounded border border-blue-100">
                    Anunciados: {selectedReferredForProfile.products_on_site ?? 0}
                  </span>
                  <span className="bg-green-50 text-green-700 px-2.5 py-1 rounded border border-green-100">
                    Vendidos: {selectedReferredForProfile.products_sold ?? 0}
                  </span>
                </div>
                <div className="text-right">
                  <span className="text-gray-500 mr-2">Comissão Atual:</span>
                  <span className="text-[#849D70] font-bold text-sm">
                    {selectedReferredForProfile.referred_commission_rate ?? 0}%
                  </span>
                </div>
              </div>

              {/* Abas Anunciados / Vendidos / Pagos */}
              <div className="w-full h-auto flex flex-wrap justify-start bg-white border border-gray-200 rounded-lg p-1.5 gap-1.5 mb-4">
                <button
                  onClick={() => {
                    setReferredProfileTab('published');
                    fetchReferredProfileProducts(selectedReferredForProfile.id, 'published');
                  }}
                  className={`flex-1 min-w-[120px] sm:min-w-[130px] h-auto px-3.5 py-2.5 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${referredProfileTab === 'published'
                    ? "!bg-[#D4C070] !text-white shadow-sm"
                    : "text-[#68686A] hover:bg-[#EEF1F2]"
                    }`}
                >
                  <Package className="h-4 w-4 mr-1.5 shrink-0" />
                  <span>Anunciados</span>
                </button>
                <button
                  onClick={() => {
                    setReferredProfileTab('saled');
                    fetchReferredProfileProducts(selectedReferredForProfile.id, 'saled');
                  }}
                  className={`flex-1 min-w-[120px] sm:min-w-[130px] h-auto px-3.5 py-2.5 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${referredProfileTab === 'saled'
                    ? "!bg-[#D4C070] !text-white shadow-sm"
                    : "text-[#68686A] hover:bg-[#EEF1F2]"
                    }`}
                >
                  <DollarSign className="h-4 w-4 mr-1.5 shrink-0" />
                  <span>Vendidos</span>
                </button>
                <button
                  onClick={() => {
                    setReferredProfileTab('paidout');
                    fetchReferredProfileProducts(selectedReferredForProfile.id, 'paidout');
                  }}
                  className={`flex-1 min-w-[120px] sm:min-w-[130px] h-auto px-3.5 py-2.5 rounded-md flex items-center justify-center text-xs font-semibold transition-colors ${referredProfileTab === 'paidout'
                    ? "!bg-[#D4C070] !text-white shadow-sm"
                    : "text-[#68686A] hover:bg-[#EEF1F2]"
                    }`}
                >
                  <Star className="h-4 w-4 mr-1.5 shrink-0" />
                  <span>Pagos</span>
                </button>
              </div>

              {/* Grid de Produtos */}
              {loadingReferredProfileProducts ? (
                <div className="flex justify-center py-10">
                  <Loader2 className="animate-spin h-6 w-6 text-[#D4C070]" />
                </div>
              ) : referredProfileProducts.length === 0 ? (
                <div className="text-center py-8 text-gray-500 text-xs italic bg-gray-50 rounded-lg">
                  Nenhum produto nesta categoria para este indicado.
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
                  {referredProfileProducts.map((product) => (
                    <div key={product.id} className="relative flex flex-col bg-white border border-gray-200 rounded-lg overflow-hidden hover:shadow-md transition-shadow p-3">
                      <div className="flex items-center gap-3">
                        {product.images?.[0] ? (
                          <img
                            src={getImageUrl(typeof product.images[0] === 'string' ? product.images[0] : (product.images[0]?.image || product.images[0]?.url || ''))}
                            alt={product.name}
                            className="w-12 h-12 sm:w-14 sm:h-14 object-cover rounded bg-white border border-gray-200 shrink-0"
                          />
                        ) : (
                          <div className="w-12 h-12 sm:w-14 sm:h-14 bg-gray-50 flex items-center justify-center rounded border border-gray-200 text-gray-400 shrink-0">
                            <Package className="w-5 h-5 opacity-20" />
                          </div>
                        )}
                        <div className="flex-1 min-w-0">
                          <h3 className="font-medium text-gray-900 break-words line-clamp-2 text-xs" title={product.name}>
                            {product.name}
                          </h3>
                          <p className="text-[11px] text-[#68686A]">Ref: {product.sku || '-'}</p>
                        </div>
                      </div>

                      <div className="flex-1 flex flex-col mt-3">
                        <div className="bg-[#849D70]/5 p-2.5 rounded border border-[#849D70]/10">
                          <div className="flex justify-between items-center font-bold text-xs">
                            <span className="text-[#849D70]">
                              Comissão ({product.referred_commission_rate ?? 0}%):
                            </span>
                            <span className="text-[#849D70] font-bold text-sm">
                              {formatCurrency(product.estimated_commission || 0)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <DialogFooter className="flex justify-between items-center mt-4 pt-3 border-t border-gray-100">
              <Button
                variant="outline"
                onClick={() => navigate(`/clientes/${selectedReferredForProfile.id}`)}
                className="text-[#D4C070] border-[#D4C070]/40 hover:bg-[#D4C070]/10 text-xs font-semibold"
              >
                Ir para Cadastro Completo
              </Button>
              <Button
                onClick={() => setReferredProfileDialogOpen(false)}
                className="bg-gray-900 hover:bg-gray-800 text-white text-xs font-bold"
              >
                Fechar
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      )}
    </main>
  );
}

export default ProdutosClientePage;
